import type { Translation } from '../i18n-types';
import baseLanguageValues from '../en-US';

export const translationValues: Partial<Translation> = {
    SHEETS: 'Tabellenblätter',
    DASHBOARDS: 'Dashboards',
    DATABASE_TABLE: 'Datenbanktabelle',
    VARIABLES: 'Variablen',
    FILES: 'Dateien',
    APPS: 'Apps',
    LABEL: 'Bezeichnung',
    EDIT_TYPE: 'Typ bearbeiten',
    EDITING_ROW: 'Zeile {label} bearbeiten',
    CREATE_NEW_ROW: 'Neue Zeile erstellen',
    ADD: 'Hinzufügen',
    MULTIPLY: 'Multiplizieren',
    SET: 'Setzen',
    PERCENT_CHANGE: 'Prozentuale Änderung',
    NAME: 'Name',
    NAME_AND_STYLE: 'Name & Stil',
    PATH: 'Pfad',
    SHARE_WITH: 'Teilen mit',
    SUBMIT: 'Absenden',
    EDIT: 'Bearbeiten',
    ANY: 'Beliebig',
    VIEW: 'Ansicht',
    EDITING: 'Bearbeiten',
    DUPLICATE: 'Duplizieren',
    DUPLICATE_SHEET_LOADING: 'Tabellenblatt wird dupliziert...',
    DUPLICATE_SHEET_SUCCESS: 'Tabellenblatt erfolgreich dupliziert',
    DUPLICATE_SHEET_ERROR: 'Fehler beim Duplizieren des Tabellenblatts',
    DUPLICATE_FOLDER_LOADING: 'Ordner wird dupliziert...',
    DUPLICATE_FOLDER_SUCCESS: 'Ordner erfolgreich dupliziert',
    DUPLICATE_FOLDER_ERROR: 'Fehler beim Duplizieren des Ordners',
    DELETE_TILE: 'Kachel löschen',
    MATCH_CASE: 'Groß-/Kleinschreibung beachten',
    SEARCH: 'Suchen',
    SEARCH_VALUES: 'Werte suchen',
    IMPORT: 'Import',
    MODEL_HEALTH: 'Modellzustand',
    CHECKLIST: 'Prüfliste',
    DYNAMIC_ANALYSIS: 'Dynamische Analyse',
    STATIC_ANALYSIS: 'Statische Analyse',
    CALCULATION_LOGS: 'Berechnungsprotokolle',
    ERROR_MESSAGE: 'Fehlermeldung',
    CALCULATION_TIME_MS: 'Berechnungszeit (ms)',
    ERRORS: 'Fehler',
    WARNINGS: 'Warnungen',
    AMPLIFICATION_FACTOR: 'Verstärkungsfaktor',
    CELL_COUNT_ESTIMATE: 'Zellenanzahl (Schätzung)',
    NO_CALCULATION_ERRORS: 'Keine Berechnungsfehler',
    CALCULATION_ERRORS: 'Berechnungsfehler gefunden',
    NO_MODELLING_ERRORS: 'Keine Modellierungsfehler',
    MODELLING_ERRORS: 'Modellierungsfehler gefunden',
    MODEL_FULLY_LOADED: 'Modell vollständig geladen',
    MODEL_NOT_LOADED: 'Modell nicht geladen',
    SHARING: 'Freigabe',
    ASSIGNMENT: 'Aufgabe',
    ASSIGNMENTS: 'Aufgaben',
    LOAD_MORE: 'Mehr laden',
    SHARE: 'Teilen',
    OPEN: 'Öffnen',
    NONE: 'Keine',
    TABLE: 'Tabelle',
    VALUE: 'Wert',
    DATE: 'Datum',
    NONE_SELECTED: 'Keine ausgewählt',
    VALUE_FOR_MONTH: 'Wert für Monat',
    DESCRIPTION: 'Beschreibung',
    NOTES: 'Notizen',
    CUSTOM_FIELD: 'Benutzerdefiniertes Feld',
    TABLE_DESCRIPTION: 'Tabellenbeschreibung',
    EDIT_COLUMN: 'Spalte bearbeiten',
    COLUMN_TYPE: 'Spaltentyp',
    MONTH: 'Monat',
    VARIABLE_AND_DIMENSIONS: 'Variable & Dimensionen',
    SHOW_UNMAPPED: 'Nur nicht zugeordnete Elemente anzeigen',
    MANUAL_MAPPING: 'Manuelle Zuordnung',
    CLEAR: 'Leeren',
    AUTODETECT: 'Automatisch erkennen',
    FILTER: 'Filter',
    SELECT_ALL_BRACKETS: '(Alle auswählen)',
    BLANK_CELLS_BRACKETS: '(Leere Zellen)',
    SELECT_DIMENSIONS: 'Dimensionen auswählen',
    CONFIRM: 'Bestätigen',
    REMOVE_ALL_MAPPINGS_CONFIRM: 'Sind Sie sicher, dass Sie alle Zuordnungen entfernen möchten?',
    REMOVE_MANUALLY_ADDED_MAPPING_TAGS: 'Diese Aktion entfernt alle manuell hinzugefügten Zuordnungs-Tags.',
    ERROR_IMPORTING_FILE: 'Fehler beim Importieren der Datei',
    CHOOSE_JOB_TO_REPLACE: 'Auftrag zum Ersetzen auswählen',
    PREVIOUS_IMPORTS: 'Vorherige Importe',
    WELCOME_TO_IMPORT: 'Willkommen beim Import.',
    IMPORT_SPREADSHEETS: 'Importieren Sie Ihre Tabellen aus Excel direkt in Farseer und verwalten Sie diese.',
    DRAG_FILE_HERE: 'Datei hierher ziehen',
    OR: 'ODER',
    BROWSE: 'Durchsuchen',
    IMPORT_MISSING_MEMBERS: 'Fehlende Mitglieder importieren',
    IMPORT_VALUES: 'Werte importieren',
    NO_COLUMN_SET_AS_TABLE: 'Keine Spalte als Dimensionstabelle gesetzt',
    NO_COLUMN_SET_AS_VALUE: 'Keine Spalte als Wert gesetzt',
    MISSING_MEMBERS: 'Es gibt fehlende Dimensionsmitglieder',
    SELECT_ALL: 'Alle auswählen',
    DESCRIPTION_COLUMN: 'Beschreibungsspalte',
    CONNECTED_DIMENSIONS_COLUMN: 'Spalte für verbundene Dimensionen',
    CANCEL: 'Abbrechen',
    CONTINUE: 'Fortfahren',
    CREATE_DIMENSIONS: 'Dimensionen erstellen',
    SELECT_CONNECTION: 'Verbindung auswählen',
    CLOSE: 'Schließen',
    SAVE: 'Speichern',
    DELETE: 'Löschen',
    REMOVE: 'Entfernen',
    DELETING_ASSIGNMENT: 'Aufgabe{multiple} wird gelöscht...',
    DELETED_ASSIGNMENT: 'Aufgabe{multiple} gelöscht!',
    FAILED_DELETE_ASSIGNMENT: 'Löschen der Aufgabe{multiple} fehlgeschlagen',
    DELETE_ASSIGNMENT: 'Aufgabe{multiple} löschen',
    DELETE_ASSIGNMENT_CONFIRMATION: 'Möchten Sie die ausgewählte Aufgabe{multiple} löschen?',
    COLUMNS: 'Spalten',
    FORMATTING: 'Formatierung',
    PRESERVE_FORMATTING: 'Formatierung beibehalten',
    CUSTOM_FORMATTING: 'Benutzerdefinierte Formatierung',
    GROUP_OUTLIERS: 'Ausreißer gruppieren',
    VERSIONS: 'Versionen',
    NONE_VERSION: 'Keine',
    APPLY_TO_ALL_YEARS: 'Auf alle Jahre anwenden',
    SHEET_OPTIONS: 'Tabellenblattoptionen',
    DASHBOARD_OPTIONS: 'Dashboard-Optionen',
    LOCK_GRID: 'Raster sperren',
    RESPONSIVE_LAYOUT: 'Responsives Layout',
    AUTO_REFRESH_DASHBOARD: 'Dashboard automatisch aktualisieren',
    REFRESH_DASHBOARD: 'Dashboard aktualisieren',
    ONLY_WITH_DATA: 'Nur mit Daten',
    OWD_INCLUDE_MEASURES: 'Kennzahlen einschließen',
    STACKED: 'Gestapelt',
    TIMELINE: 'Zeitleiste',
    RESET_COLUMN_ORDER: 'Spaltenreihenfolge zurücksetzen',
    STANDARD_COLUMNS_NAME: 'Name',
    STANDARD_COLUMNS_DESCRIPTION: 'Beschreibung',
    STANDARD_COLUMNS_NAME_PLUS_DESCRIPTION: 'Name + Beschreibung',
    DOWNLOADING_FILE: 'Datei wird heruntergeladen',
    FILE_DOWNLOADED: 'Datei heruntergeladen',
    FAIL_FILE_DOWNLOAD: 'Export aus angegebener Konfiguration fehlgeschlagen',
    ADD_TO_DASHBOARD: 'Zum Dashboard hinzufügen',
    SUBMIT_ENTRIES_CONFIRMATION: 'Sind Sie sicher, dass Sie Ihre Einträge absenden möchten?',
    FURTHER_CHANGES_AND_LINK_LOCKED_AFTER_SUBMIT: 'Nach dem Absenden können keine weiteren Änderungen vorgenommen werden und der Link wird gesperrt.',
    LINK_NOT_FOUND: 'Link nicht gefunden.',
    LINK_EXPIRED: 'Dieser Link ist abgelaufen.',
    DEPLOYMENT: 'Bereitstellung',
    UNKNOWN: 'Unbekannt',
    FILE_SIZE_10GB: 'Dateigröße > 10 GB',
    FILE_SIZE_64MB: 'Dateigröße > 64 MB',
    FILE_SIZE_1MB: 'Dateigröße > 1 MB',
    FILE_SIZE_TOO_LARGE: 'Dateigröße zu groß',
    UPLOADED: 'Hochgeladen',
    ERROR_UPLOADING_FILE: 'Fehler beim Hochladen der Datei',
    FOLDER_NAME: 'Ordnername',
    NEW_DIMENSION_TABLE: 'Neue Dimensionstabelle',
    NEW_VARIABLE: 'Neue Variable',
    NEW_DASHBOARD: 'Neues Dashboard',
    NEW_SHEET: 'Neues Tabellenblatt',
    UPLOAD_FILE: 'Datei hochladen',
    NEW_FOLDER: 'Neuer Ordner',
    NEW_REMOTE_JOB: 'Neue App',
    DOWNLOAD: 'Herunterladen',
    DELETE_MENU_ITEM_CONFIRM: 'Sind Sie sicher, dass Sie {menuItem} löschen möchten?',
    USER_REMOVED: 'Benutzer wurde entfernt!',
    FAILED_USER_REMOVE: 'Benutzer konnte nicht entfernt werden',
    USER_DELETING: 'Benutzer {fullName} wird gelöscht',
    USER_DELETING_CONFIRM: 'Sind Sie sicher, dass Sie den Benutzer {fullName} löschen möchten?',
    CONFIRM_DELETE_OPERATION: 'Löschvorgang bestätigen',
    DELETE_YEAR_CONFIRMATION: 'Sind Sie sicher, dass Sie das Jahr {year} löschen möchten?',
    DELETE_VARIATION_CONFIRMATION: 'Sind Sie sicher, dass Sie die Version {name} löschen möchten?',
    YEARS: 'Jahre',
    YEAR: 'Jahr',
    ADD_YEAR: '{year} hinzufügen',
    OPTIONS: 'Optionen',
    NO_VERSION_SELECTED: 'Keine Version ausgewählt',
    INTERVAL_START_GREATER: 'Intervallanfang ist größer als einige Intervallenden',
    INTERVAL_END_GREATER: 'Intervallende ist kleiner als einige Intervallanfänge',
    INTERVAL_START_GREATED_END: 'Intervallanfang ist größer als das Ende',
    NO_NAME_INPUT: 'Aufgabe muss einen Namen haben',
    EDIT_ASSIGNMENTS: 'Aufgaben bearbeiten',
    ASSIGNMENT_NAME: 'Aufgabenname',
    VERSION: 'Version',
    ADD_VERSION: 'Version hinzufügen',
    ADD_NEW_VERSION: 'Neue Version hinzufügen',
    NEW_VERSION_NAME: 'Neuer Versionsname',
    ERROR_ADDING_VERSION: 'Fehler beim Hinzufügen der Version.',
    NAME_AND_COLOR: 'Name & Farbe',
    ADDED_BY: 'Hinzugefügt von',
    CREATE_SERVICE_USER: 'Dienstbenutzer erstellen',
    CREATE_USER: 'Benutzer erstellen',
    USER_TYPE: 'Benutzertyp',
    STANDARD: 'Standard',
    SERVICE: 'Dienst',
    CREATED_SERVICE_USER: 'Dienstbenutzer erstellt',
    FAILED_CREATE_SERVICE_USER: 'Erstellung des Dienstbenutzers und API-Schlüssels fehlgeschlagen',
    SERVICE_USER_NAME_REQUIRED: 'Dienstbenutzername ist erforderlich',
    CREATED_USER: 'Benutzer erstellt',
    FAILED_CREATE_USER: 'Benutzer konnte nicht erstellt werden',
    LAST_NAME_REQUIRED: 'Nachname ist erforderlich',
    FIRST_NAME_REQUIRED: 'Vorname ist erforderlich',
    EMAIL_REQUIRED: 'E-Mail erforderlich',
    PASSWORD_REQUIRED: 'Passwort erforderlich',
    PASSWORD_INCORRECT: 'Passwort falsch',
    FIRST_NAME: 'Vorname',
    LAST_NAME: 'Nachname',
    EMAIL: 'E-Mail',
    PASSWORD: 'Passwort',
    CONFIRM_PASSWORD: 'Passwort bestätigen',
    API_KEY: 'API-Schlüssel',
    CREATED_SERVICE_USER_API_KEY: 'API-Schlüssel für Dienstbenutzer {serviceUserName} erstellt',
    API_KEY_COPIED_TO_CLIPBOARD: 'API-Schlüssel in die Zwischenablage kopiert',
    CONNECT: 'Verbinden',
    DISCONNECT: 'Trennen',
    MIXED_VERSIONS: 'Gemischte Versionen',
    MIXED: 'Gemischt',
    USE_RESTRICTIONS: 'Eingabe auf Versionen und Intervalle beschränken',
    ALLOW_ENTRY_ON_PROPERTY_COLUMNS: 'Eingabe in Eigenschaftsspalten erlauben',
    PROPERTY_COLUMNS: 'Eigenschaftsspalten',
    USE_TIME_LIMIT: 'Zeitlimit verwenden',
    SELECT_VERSION: 'Version auswählen',
    EXPIRES_AFTER: 'Läuft ab nach',
    CHANGE: 'Ändern',
    SMART_FILTER_CHANGE: 'Änderung',
    CHANGES_SUBMITTED: 'Änderungen eingereicht. Warten auf Überprüfung.',
    SUBMITTED: 'Eingereicht',
    ASSIGNMENTS_AVAILABLE: 'Aufgaben verfügbar',
    SUBMITTING_ASSIGNMENT: 'Aufgabe wird eingereicht.',
    SUBMITED_ASSIGNMENT: 'Die Aufgabe wurde eingereicht.',
    FAIL_SUBMIT_ASSIGNMENT: 'Aufgabe konnte nicht eingereicht werden.',
    ASSIGNMENT_LABEL_CREATED: 'Bezeichnung erstellt und der Aufgabe hinzugefügt',
    SUBMIT_CHANGES: 'Änderungen absenden?',
    SUBMIT_CHANGES_CONFIRMATION: 'Sind Sie sicher, dass Sie Ihre Änderungen absenden möchten? Danach sind keine weiteren Bearbeitungen möglich, der Vorgang wird als bereit zur Überprüfung markiert und der Eigentümer dieses Tabellenblatts wird benachrichtigt.',
    CANT_UNDONE_ACTION: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    APP_LANGUAGE: 'App-Sprache',
    TARGET_VERSION_SAME_AS_SOURCE_VERSION_ERROR: 'Zielversion darf nicht gleich der Quellversion sein.',
    TARGET_VERSION: 'Zielversion',
    SELECT_TARGET_VERSION: 'Bitte Zielversion auswählen.',
    SOURCE_VERSION: 'Quellversion',
    SELECT_SOURCE_VERSION: 'Bitte Quellversion auswählen.',
    ROW_TAGS: 'Zeilen-Tags',
    DELETE_THIS_ROW: 'Diese Zeile löschen',
    SELECT_PARENT_TAG_FOR_MULTIPLE_ROWS_GENERATING: 'Übergeordneten Tag auswählen, um mehrere Zeilen zu generieren',
    GLOBAL_SEARCH_PLACEHOLDER: 'Tabellenblätter, Dashboards, Datenbanktabellen, Apps und Variablen durchsuchen',
    NO_RESULTS_FOUND: 'Keine Ergebnisse gefunden.',
    NEW_TILE: 'Neue Kachel',
    SLICER_STATE_SAVED: 'Slicer-Status für alle gespeichert!',
    INVALID_LINK: 'Ungültiger Link',
    LINK_NOT_EXIST: 'Link existiert nicht.',
    ACCESS_NOT_GRANTED: 'Zugriff auf Host nicht gewährt.',
    CONTACT_ADMIN: 'Bitte kontaktieren Sie Ihren Administrator für weitere Informationen.',
    LOGOUT: 'Abmelden',
    REGENERATING_LINKS: 'Links werden neu generiert...',
    REGENERATED: 'Neu generiert!',
    FAILED_REGENERATING_LINKS: 'Fehler beim Neugenerieren der Links für ausgewählte öffentliche Aufgaben.',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS: 'Links für ausgewählte Aufgaben neu generieren?',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS_CONFIRMATION: 'Sind Sie sicher, dass Sie die Links für die ausgewählten Aufgaben neu generieren möchten? Die alten Links werden ungültig. Diese Aktion kann nicht rückgängig gemacht werden.',
    REGENERATE: 'Neu generieren',
    REGENERATE_LINK: 'Link neu generieren',
    SHEET_NOT_FOUND: 'Tabellenblatt nicht gefunden',
    CLUSTER_NOT_FOUND: 'Cluster nicht gefunden',
    PARENT_CLUSTER_NOT_FOUND: 'Übergeordneter Cluster nicht gefunden',
    TAG_NOT_FOUND: 'Tag nicht gefunden',
    SHEET_ID_NOT_FOUND: 'Tabellenblatt-ID nicht gefunden',
    FAIL_CREATE_ROW: 'Zeile konnte nicht erstellt werden',
    FAIL_CREATE_CLUSTER: 'Cluster konnte nicht erstellt werden',
    ROW_CREATED: 'Zeile erstellt',
    COLUMN_CREATED: 'Spalte erstellt',
    DIMENSION_CREATED: 'Dimension erstellt',
    NOT_IMPLEMENTED_YET: 'Noch nicht implementiert',
    VARIABLE_SHOULD_CONTAIN_ONLY_VARIABLES: 'Variablenfeld sollte nur Variablen enthalten',
    UNKNOWN_ZONE_SINGLE_VALUE: 'Unbekannte Zone im Einzelwert',
    FILTER_FIELD_SHOULD_CONTAIN_DIMENSION_TAGS: 'Filterfeld sollte Dimensions-Tags enthalten',
    UNKNOWN_ZONE_DATA_EDITOR: 'Unbekannte Zone im Dateneditor',
    VARIABLE_FILED_SHOULD_CONTAIN_ACCOUNT_TAG: 'Variablenfeld sollte Konto-Tags enthalten',
    CUSTOM_COLUMN_NOT_FOUND: 'Benutzerdefinierte Spalte nicht gefunden',
    CANT_ADD_TO_COLUMN: '{tagType} kann nicht zum Spaltentyp {columnType} hinzugefügt werden',
    TAG_ALREADY_ADDED: 'Dieser Tag wurde bereits hinzugefügt',
    MODEL_IMPORT_IN_PROGRESS: 'Modellimport wird durchgeführt...',
    MODEL_IMPORT_SUCCESS: 'Modell erfolgreich importiert.',
    CODE_EDITOR_ALLOW_CHANGES: 'Dem Code-Editor erlauben, Änderungen am Modell vorzunehmen:',
    ALLOW_ALL: 'Alles erlauben',
    DELETE_MEMBER_ROWS: 'Zeilen löschen',
    DELETE_TABLES: 'Tabellen löschen',
    DELETE_VARIABLES: 'Variablen löschen',
    DELETE_COLUMNS: 'Spalten löschen',
    DELETE_CELLS: 'Zellen löschen',
    DELETE_EVERYTHING: 'Alles löschen beim Anwenden von Änderungen',
    DRY_RUN: 'Testlauf',
    MODEL_CODE_EDITOR: 'Modell-Code-Editor',
    MODEL_IMPORT_EXPORT: 'Modell-Import/Export',
    MODEL_IMPORT: 'Modellimport',
    MODEL_EXPORT: 'Modellexport',
    MODEL_USE_IN_EXPORT: 'Beim Export verwenden',
    MODEL_OBJECT_TYPE: {
        DTAB: 'Dimensionstabellen',
        DMEM: 'Dimensionsmitglieder',
        VAR: 'Variablen',
        CELL: 'Zellen',
    },
    LOADING: 'Wird geladen...',
    CHAT_STATUS_ANALYZING_CONTEXT: 'Ihre Frage wird analysiert',
    CHAT_STATS_ACTIONS: '{count} {{Aktion|Aktionen}}',
    CHAT_STATS_CONTEXT: '{tokens} Kontext',
    CHAT_STATS_DURATION_TOOLTIP: 'Wie lange die Generierung dieser Antwort gedauert hat',
    CHAT_STATS_ACTIONS_TOOLTIP: 'Wie viele Aktionen der Agent ausgeführt hat (Skills laden, Code ausführen)',
    CHAT_STATS_CONTEXT_TOOLTIP: 'Aktuelle Größe des Gesprächskontexts. Ältere Nachrichten werden zusammengefasst, sobald er zu groß wird.',
    CHAT_DEFAULT_TITLE: 'Chat',
    CHAT_ENTER_FULLSCREEN: 'Vollbild öffnen',
    CHAT_EXIT_FULLSCREEN: 'Vollbild beenden',
    CHAT_RENAME: 'Chat umbenennen',
    CHAT_DELETE: 'Chat löschen',
    CHAT_CREATE_NEW: 'Neuen Chat erstellen',
    CHAT_MESSAGE_PLACEHOLDER: 'Nachricht an FarseerAI...',
    CHAT_SEND: 'Senden',
    CHAT_RENAME_TITLE: 'Chat umbenennen',
    CHAT_HELP_QUESTION: 'Wie kann ich Ihnen heute helfen',
    CHAT_SUGGESTED: 'Vorschläge',
    CHAT_SUGGESTED_SUMMARY: 'Geben Sie mir eine kurze Zusammenfassung des Modells',
    CHAT_SUGGESTED_DIMENSIONS: 'Gibt es Variablen, die mehr Dimensionen haben als die in ihrer Formel verwendeten Variablen?',
    CHAT_SUGGESTED_DELAY: 'Verwenden Variablen die Funktion delay()?',
    CHAT_SUGGESTED_ON_DEMAND: 'Alle On-Demand-Variablen auflisten',
    CHAT_SUGGESTED_MEASURES: 'Alle Kennzahlen auflisten',
    CHAT_SUGGESTED_FIXED_DIMENSION: 'Alle Variablen mit einer festen Dimension auflisten',
    CHAT_SUGGESTED_DATE_PROPERTY: 'Alle Dimensionen mit einer Datumseigenschaft auflisten',
    CHAT_CREATED: 'Chat erstellt!',
    CHAT_CREATED_NEW: 'Neuer Chat erstellt!',
    CHAT_RENAMED: 'Chat umbenannt!',
    CHAT_DELETED: 'Chat gelöscht!',
    CHAT_FAILED_CREATE: 'Neuer Chat konnte nicht erstellt werden.',
    CHAT_FAILED_LOAD: 'Chats konnten nicht geladen werden.',
    CHAT_FAILED_RENAME: 'Chat konnte nicht umbenannt werden.',
    CHAT_FAILED_DELETE: 'Chat konnte nicht gelöscht werden.',
    CHAT_FAILED_CANCEL: 'Die Anfrage konnte nicht abgebrochen werden.',
    CHAT_FEEDBACK_FAILED: 'Feedback konnte nicht gespeichert werden.',
    CHAT_FEEDBACK_THUMBS_UP: 'Gute Antwort',
    CHAT_FEEDBACK_THUMBS_DOWN: 'Schlechte Antwort',
    CHAT_FEEDBACK_COMMENT_TITLE: 'Teilen Sie uns mit, was schiefgelaufen ist',
    CHAT_FEEDBACK_COMMENT_PLACEHOLDER: 'Was war hilfreich oder was ist schiefgelaufen? (optional)',
    CHAT_FEEDBACK_COMMENT_SAVE: 'Speichern',
    CHAT_FEEDBACK_CLEAR: 'Feedback löschen',
    CHAT_AGENT_TYPE_ANALYST: 'Analyst',
    ADVANCED_SETTINGS: 'Erweiterte Einstellungen',
    INVALID_JSON_ERROR: 'Ungültiges JSON: {message}',
    MAINTENANCE_MODE_CURRENTLY_ENABLED: 'Wartungsmodus ist derzeit aktiviert',
    MAINTENANCE_MODE_ENABLED: 'Wartungsmodus aktiviert',
    CONTACT_ADMIN_FOR_INFO: 'Bitte warten oder kontaktieren Sie Ihren Administrator für weitere Informationen.',
    RETRY: 'Erneut versuchen',
    COPY_LINK: 'Link kopieren',
    COPY_DATA_FROM: 'Daten kopieren von',
    ROWS_CUT: 'Zeilen ausgeschnitten',
    ROWS_COPIED: 'Zeilen kopiert',
    ROWS_MOVED: 'Zeilen verschoben',
    ROWS_PASTED: 'Zeilen eingefügt',
    CELLS_CUT: 'Zellen ausgeschnitten',
    CELLS_COPIED: 'Zellen kopiert',
    FAILED_CELLS_COPIED: 'Zellen konnten nicht kopiert werden {message}',
    CANNOT_CELLS_PASTED: 'Zellen können hier nicht eingefügt werden',
    TAG: 'Tag',
    ACTION: 'Aktion',
    MANAGE_CONNECTIONS_FOR: 'Verbindungen verwalten für',
    RENAME: 'Umbenennen',
    RENAME_FILE_EXTENSION_REQUIRED: 'Dateinamen benötigen eine Erweiterung, z. B. .csv oder .xlsx.',
    RENAME_FILE_EXTENSION_CHANGE_TITLE: 'Dateierweiterung ändern?',
    RENAME_FILE_EXTENSION_CHANGE_QUESTION: 'Dadurch wird die Erweiterung von „.{oldExt}“ in „.{newExt}“ geändert, was beeinflussen kann, wie die Datei geöffnet wird. Möchten Sie fortfahren?',
    REMOVE_COLUMN: 'Spalte entfernen',
    REMOVE_CONNECTION: 'Verbindung entfernen',
    TABLE_CONNECTION: 'Tabellenverbindung',
    TEXT: 'Text',
    TEXT_COLUMN: 'Textspalte',
    NUMBER: 'Zahl',
    NUMBER_COLUMN: 'Zahlenspalte',
    NEW_NUMBER_COLUMN: 'Neue Zahlenspalte',
    FILE: 'Datei',
    FILE_COLUMN: 'Dateispalte',
    DATE_COLUMN: 'Datumsspalte',
    EDIT_TAG_TYPE: '{tagTypeName} bearbeiten',
    DELETE_TAG_TYPE: '{tagTypeName} löschen',
    DELETE_TAG_TYPE_DATA: '{tagTypeName}-Daten löschen',
    CONNECTIONS: 'Verbindungen',
    EDIT_CONNECTIONS: 'Verbindungen bearbeiten',
    CLEAR_FIELD: 'Feld leeren',
    ERROR_CLEAR_FIELD: 'Fehler beim Leeren des Felds',
    REPLACE_FILE: 'Datei ersetzen',
    DOWNLOAD_FILE: 'Datei herunterladen',
    DOWNLOAD_ORIGINAL_FILE: 'Originaldatei herunterladen',
    FILE_DOES_NOT_EXIST: 'Datei existiert nicht',
    DELETE_FILE: 'Datei löschen',
    ERROR_DELETE_FILE: 'Fehler beim Löschen der Datei',
    LOCKS: 'Sperren',
    LOCK_REFERENCES_DELETED_ENTITIES: 'Diese Sperre verweist auf gelöschte Entitäten',
    TABLE_SETTINGS: 'Tabelleneinstellungen',
    NEW_MEMBER: 'Neues Mitglied',
    SORT_TABLE: 'Tabelle sortieren',
    NAME_ASCENDING: 'Name aufsteigend',
    NAME_DESCENDING: 'Name absteigend',
    ADD_SORT_RULE: 'Sortierregel hinzufügen',
    REMOVE_ALL_SORT_RULES: 'Alle Sortierregeln entfernen',
    '1_SORT': '1 Sortierung',
    N_SORTS: '{count} Sortierungen',
    DESCRIPTION_ASCENDING: 'Beschreibung aufsteigend',
    DESCRIPTION_DESCENDING: 'Beschreibung absteigend',
    SORTING_DIMENSIONS: 'Dimensionen werden sortiert...',
    DIMENSIONS_SORTED: 'Dimensionen sortiert!',
    ERROR_SORTING_DIMENSIONS: 'Fehler beim Sortieren der Dimensionen.',
    EDITING_TIMELINE_SLICER: 'Zeitleisten-Slicer "{title}" bearbeiten',
    CREATE_NEW_TIMELINE_SLICER: 'Neuen Zeitleisten-Slicer erstellen',
    INTERVAL_START: 'Intervallanfang',
    INTERVAL_END: 'Intervallende',
    FORMAT: 'Format',
    OPERATION: 'Operation',
    MY_PROFILE_INFORMATION: 'Meine Profilinformationen',
    PROFILE_SETTINGS: 'Profileinstellungen',
    ADD_PHOTO: 'Foto hinzufügen',
    CHANGE_PHOTO: 'Foto ändern',
    UPDATE_PHOTO: 'Foto aktualisieren',
    REMOVE_PHOTO: 'Foto entfernen',
    DECIMAL_SEPARATOR: 'Dezimaltrennzeichen',
    DATE_FORMAT: 'Datumsformat',
    DATE_SEPARATOR: 'Datumstrennzeichen',
    ACCESSIBLE_CHART_PATTERNS: 'Barrierefreie Muster für Diagramme',
    SET_AS_DEFAULT_PALETTE: 'Als Standardpalette festlegen',
    SAVE_CURRENT_COLORS_AS_PALETTE: 'Aktuelle Farben als Palette speichern',
    DELETE_PALETTE: 'Palette löschen',
    FILL_STYLE: 'Füllstil',
    SOLID: 'Ausgefüllt',
    HATCHED: 'Schraffiert',
    VARIABLE: 'Variable',
    DIMENSION: 'Dimension',
    CREATE_OR_GENERATE_NEW_ROWS: 'Neue Zeilen erstellen oder generieren',
    CREATE_ROW_AS: '{row} erstellen als',
    GENERATE_ROWS_FROM: 'Zeile(n) generieren aus',
    CREATE_NEW_VARIABLE: 'Neue Variable erstellen',
    ENTER_FORMULA_FOR: 'Formel für {variableName} eingeben',
    SELECT_A_VARIABLE_FORMULA: 'Variable auswählen, um ihre Formel anzuzeigen oder zu bearbeiten',
    DATABASE_AND_PROPERTIES: 'Datenbankobjekte & Eigenschaften',
    FOLDER_EMPTY: 'Ordner leer',
    DASHBOARD_EMPTY: 'Dashboard leer',
    DASHBOARD_HINT: 'Beginnen Sie mit Ihrem Dashboard, indem Sie eine Kachel erstellen.',
    YEARS_SETTINGS: 'Jahreseinstellungen',
    FINANCIAL_YEAR_STARTING_MONTH: 'Startmonat des Geschäftsjahres',
    UPDATING_FINANCIAL_YEAR_STARTING_MONTH: 'Startmonat des Geschäftsjahres wird aktualisiert',
    FINANCIAL_YEAR_STARTING_MONTH_UPDATED: 'Startmonat des Geschäftsjahres aktualisiert',
    SOMETHING_WENT_WRONG: 'Etwas ist schiefgelaufen.',
    SEARCH_FOR_USERS: 'Nach Benutzern suchen...',
    SEARCH_FOR_GROUPS: 'Nach Gruppen suchen...',
    SEARCH_BY_GROUP_OR_USER: 'Nach Gruppe oder Benutzer suchen',
    USERS: 'Benutzer',
    GROUPS: 'Gruppen',
    USER_OR_GROUP: 'Benutzer/Gruppe',
    PERMISSIONS: 'Berechtigungen',
    END_DATE_MUST_BE_GREATER_THAN_START_DATE: 'Enddatum muss größer als das Startdatum sein',
    HISTORY_DATA_CANNOT_OVERLAP_WITH_FORECAST_DATA: 'Historische Daten dürfen nicht mit Prognosedaten überlappen',
    PLEASE_CHOOSE_AN_ACCOUNT_TAG: 'Bitte wählen Sie einen Konto-Tag',
    ERROR_STARTING_FORECAST: 'Fehler beim Starten der Prognose',
    CUSTOM_FORECAST: 'Benutzerdefinierte Prognose',
    HISTORICAL_DATA_FROM: 'Historische Daten von',
    HISTORICAL_DATA_TO: 'Historische Daten bis',
    SOURCE_VARIABLE_AND_DIMENSIONS: 'Quellvariable & Dimensionen',
    ERROR: 'Fehler {message}',
    FORECAST: 'Prognose',
    VIEW_FORECASTS_FOR_PERIOD: 'Prognosen für Zeitraum anzeigen',
    NO_JOBS_FOR_SELECTED_PERIOD: 'Keine Aufträge für den ausgewählten Zeitraum',
    ACTIVE_JOBS: 'Aktive Aufträge',
    FINISHED_JOBS: 'Abgeschlossene Aufträge',
    COMPLETED_ON: 'Abgeschlossen am {time}',
    FORECAST_PROGRESS: 'Prognosefortschritt & Verlauf',
    ERROR_LOADING_FORECAST_JOBS: 'Fehler beim Laden der Prognoseaufträge.',
    PAGE: 'Seite',
    EDIT_ENTRY: 'Eintrag bearbeiten',
    NEW_ENTRY_BY_DATE: 'Neuer Eintrag nach Datum',
    TAGS: 'Tags',
    ADD_TAG: 'Tag hinzufügen',
    START_YEAR: 'Startjahr',
    START_MONTH: 'Startmonat',
    END_YEAR: 'Endjahr',
    END_MONTH: 'Endmonat',
    MUST_SELECT_ROW: 'Sie müssen eine Zeile auswählen',
    TITLE: 'Titel',
    SUBTITLE: 'Untertitel',
    FOOTNOTES: 'Fußnoten',
    ROW: 'Zeile',
    SELECT_ROW: 'Zeile auswählen',
    COLUMN: 'Spalte',
    ROW_NAME_DISPLAY: 'Zeilennamenanzeige',
    BOTH: 'Beide',
    SHARED_COLUMN_CONFIG_PRESET: 'Gemeinsame Spaltenkonfigurationsvorlage',
    SHOW_ZERO_SUM_ROWS: 'Zeilen mit Nullsumme anzeigen',
    USE_DATA_FROM_TIMELINE_SLICER: 'Daten vom Zeitleisten-Slicer verwenden',
    USE_DATA_FROM_DIMENSION_SLICER: 'Daten vom Dimensions-Slicer verwenden',
    DELETE_TARGET_AND_RELATED_DATA: 'und zugehörige Daten?',
    DELETE_TARGET_CHILDREN: 'Unterelemente löschen von',
    DELETE_TARGET_DATA: 'Daten löschen für',
    CONFIRM_DELETE_ROW: 'Zeile löschen?',
    CONFIRM_DELETE_ROWS: '{count} Zeilen löschen?',
    CONFIRM_DELETE_ROWS_GENERATED: 'Generierte Zeilen löschen?',
    CONFIRM_DELETE_ROWS_MIXED: 'Zeilen und generierte Zeilen löschen?',
    EXPLAIN_DELETE_ROW: 'Dies wird <>{row}<> löschen',
    EXPLAIN_DELETE_ROWS_GENERATED: 'Dies wird generierte Zeilen aus <>{table}<> aus diesem Tabellenblatt löschen.',
    EXPLAIN_DELETE_ROWS_MIXED: 'Dies wird <>{count} Zeile(n)<> und generierte Zeilen aus <>{table}<> aus diesem Tabellenblatt löschen.',
    EXPLAIN_DELETE_ROWS_SUBROWS: 'Dies wird auch alle Unterzeilen löschen. Diese Aktion kann nicht rückgängig gemacht werden.',
    FAILED_DELETE_ROW: 'Zeile konnte nicht gelöscht werden',
    DELETE_ROW_AND_ITS_CHILDREN_CONFIRMATION: 'und alle Unterzeilen und Elemente?',
    NO_ACCESS_TO_DELETE_ROWS: 'Sie haben keinen Zugriff auf die referenzierten Zeilen und können diese daher nicht löschen.',
    CREATE_GROUP: 'Gruppe erstellen',
    EDIT_PERMISSIONS: 'Berechtigungen bearbeiten',
    USERS_AND_GROUPS_MANAGEMENT: 'Benutzer- & Gruppenverwaltung',
    SUM: 'Summe',
    COUNT: 'Anzahl',
    AVERAGE: 'Durchschnitt',
    CLOSING_STATE: 'Endbestand',
    BEGINNING_STATE: 'Anfangsbestand',
    FORMULA: 'Formel',
    MAX: 'Maximum',
    MIN: 'Minimum',
    YES: 'Ja',
    NO: 'Nein',
    YESTERDAY: 'Gestern',
    CONFIRM_VARIABLE_REMOVE: 'Variable entfernen bestätigen',
    CONFIRM_VARIABLES_REMOVE: 'Variablen entfernen bestätigen',
    REMOVE_VARIABLE_CONFIRMATION: 'Sind Sie sicher, dass Sie die Variable entfernen möchten',
    REMOVE_VARIABLES_CONFIRMATION: 'Sind Sie sicher, dass Sie die Variablen entfernen möchten:',
    REMOVE_VARIABLES_COUNT_CONFIRMATION: 'Sind Sie sicher, dass Sie {tagNumber} Variablen entfernen möchten?',
    EDIT_VARIABLE: 'Variable bearbeiten',
    SHARE_VARIABLE: 'Variable teilen',
    DELETE_VARIABLE_DATA: 'Variablendaten löschen',
    DELETE_VARIABLE: 'Variable löschen',
    EXPAND_MORE: 'Mehr erweitern',
    COLLAPSE_ALL: 'Alle zusammenklappen',
    VARIABLE_METRICS: 'Variablenkennzahlen',
    VARIABLE_TABLE_COLUMNS: {
        Name: 'Name',
        Description: 'Beschreibung',
        Formula: 'Formel',
        Dimensions: 'Dimensionen',
        'Read-only': 'Schreibgeschützt',
        'Roll-up type': 'Zusammenfassungstyp',
    },
    LOADING_DATA: 'Daten werden geladen…',
    SUCCESSFULLY_LOADED_DATA: 'Daten geladen',
    LOADING_DATA_FAILED: 'Daten konnten nicht geladen werden',
    LOADING_DATA_FAILED_SUBTITLE: 'Versuchen Sie, die Seite zu aktualisieren',
    WAITING: 'Warten...',
    VIEW_LOGS: 'Protokoll anzeigen',
    LOADING_DATA_LOG: 'Datenladeprotokoll',
    CALCULATION_STARTED: 'Berechnung gestartet.',
    CALCULATION_FINISHED: 'Berechnung abgeschlossen.',
    DATABASE_LOADED: 'Datenbank geladen. Anzahl der geladenen Zellen: {numberOfCells}',
    VARIABLE_CALCULATION_STARTED: 'Berechnung der Variable {variableName} gestartet. Anzahl der Eingabezellen: {numberOfCells}',
    VARIABLE_CALCULATION_ENDED: 'Berechnung der Variable {variableName} abgeschlossen. Anzahl der Zellen: {numberOfCells}, Ausgabe/Eingabe-Faktor: {outInFactor}.',
    NEW_ROW: 'Neue Zeile',
    NEW_TEMPLATE_OR_ROW: 'Neu',
    ADD_TEMPLATE_TO_TOOLBAR: 'Zur Symbolleiste hinzufügen',
    REMOVE_TEMPLATE_FROM_TOOLBAR: 'Von Symbolleiste entfernen',
    IN_TOOLBAR: 'In der Symbolleiste',
    TEMPLATE_ADDED_TO_TOOLBAR: 'Vorlage zur Symbolleiste hinzugefügt',
    TEMPLATES: 'Vorlagen',
    SELECT_A_ROW: 'Zeile auswählen',
    FILE_CANT_BE_PREVIEWED: 'Datei kann nicht in der Vorschau angezeigt werden',
    THIS_TYPE_OF: 'Dieser Typ von',
    INPUT_SETUP: 'Eingabeeinstellungen',
    ONDEMAND_CALCULATION: 'On-Demand-Berechnung',
    REFRESH_DATA: 'Daten aktualisieren',
    DISABLE_MAINTENANCE_MODE: 'Wartungsmodus deaktivieren',
    ENABLE_MAINTENANCE_MODE: 'Wartungsmodus aktivieren',
    SAVED: 'Gespeichert',
    FORMULA_ERROR: 'Formelfehler',
    UNEXPECTED: 'Unerwartet',
    INVALID_SYNTAX: 'Ungültige Syntax für',
    MISSING_TOKEN_AFTER: 'Fehlendes Token nach',
    UNNECESSARY: 'Unnötig',
    ERROR_MESSAGE_OCCURRED: 'Ein Fehler ist aufgetreten',
    INCOMPLETE_sheet_ITEM_DATA: 'Unvollständige Tabellenblatt-Elementdaten',
    FAIL_SAVE_sheet_ITEMS: 'Tabellenblatt-Elemente konnten nicht gespeichert werden',
    HEADER_COLUMNS: {
        Description: 'Beschreibung',
        Date: 'Datum',
        Version: 'Version',
        'Variable and Dimensions': 'Variable und Dimensionen',
        Value: 'Wert',
        'Value type': 'Werttyp',
        Action: 'Aktion',
    },
    DESCRIPTION_UPDATE_DATE_TAGS_FAILED: 'Aktualisierung der Beschreibungen für Monats- und Jahres-Tags fehlgeschlagen.',
    COMPARISON: 'Vergleich',
    DISALLOW: 'Nicht erlauben',
    USE_DEFAULT: 'Standard verwenden',
    SKIP_ROW: 'Zeile überspringen',
    MISSING_MEMBERS_IMPORT_NOT_ALLOWED: 'Import wird nicht zugelassen, solange fehlende Mitglieder vorhanden sind.',
    MISSING_MEMBERS_SKIP_ROWS: 'Zeilen mit fehlenden Mitgliedern werden übersprungen.',
    MISSING_MEMBERS_DEFAULT: 'Daten der fehlenden Mitglieder werden in das Standardmitglied der Tabelle importiert.',
    CONFIGURE_JOB_OPTIONS: 'Auftragsoptionen konfigurieren',
    HANDLE_MISSING_DIMENSION_MEMBERS: 'Fehlende Dimensionsmitglieder behandeln',
    IMPORT_ZEROS: 'Nullwerte importieren',
    OVERWRITE_CELLS: 'Zellen überschreiben',
    IGNORE_FINANCIAL_YEAR_OFFSET: 'Geschäftsjahr-Versatz ignorieren',
    SKIP_EMPTY_ROWS: 'Leere Zeilen überspringen',
    SKIP_REPEATING_HEADER_ROWS: 'Sich wiederholende Kopfzeilen überspringen',
    SKIP_LOW_SIGNAL_ROWS_HEURISTIC: 'Zeilen mit geringem Signal überspringen (heuristisch)',
    ROWS_WILL_BE_SKIPPED_ON_IMPORT: '{count} Zeile(n) werden beim Import übersprungen.',
    NO_ROWS_WILL_BE_SKIPPED_ON_IMPORT: 'Beim Import werden keine Zeilen übersprungen.',
    INCLUDE_IN_IMPORT: 'In Import einschließen',
    EXCLUDE_FROM_IMPORT: 'Vom Import ausschließen',
    MISSING_MEMBERS_REPLACE_ALL: 'Alle bisherigen Dimensionsmitglieder ersetzen',
    MISSING_MEMBERS_REPLACE_ALL_CONFIRMATION: 'Sind Sie sicher, dass Sie alle bisherigen Dimensionsmitglieder ersetzen möchten?',
    APPLY_MEMBERS_AND_VARIABLES_TO_VALUE_COLUMNS: 'Mitglieder und Variablen auf Wertspalten anwenden',
    WRONG_RESULT_TYPE_FOR_COLUMN: 'Falscher Ergebnistyp für Spalte {columnKey}',
    TRIED_TO_ADD_NON_UNIQUE_TAGS: 'Versuch, nicht eindeutige Tags hinzuzufügen',
    TRIED_TO_CREATE_TAG_WITH_EMPTY_NAME: 'Versuch, einen Tag mit leerem Namen zu erstellen',
    NO_PARENT_TAG_SELECTED: 'Kein übergeordneter Tag ausgewählt',
    COLUMN_MANAGER: 'Spalten',
    NO_COLUMNS: 'Keine Spalten.',
    NEW_COLUMN_TIP: 'Sie können beginnen, indem Sie ein neues Spaltenelement hinzufügen. Verwenden Sie dann die Seitenleiste, um benutzerdefinierte Spalten auszuwählen und zu erstellen.',
    NEW_COLUMN: 'Neue Spalte',
    COLUMN_TO_NUMBER_TYPE: 'Zu Zahl ändern',
    COLUMN_TO_COMPARISON_TYPE: 'Zu Vergleich ändern',
    COMPARISON_OPERATION: 'Operation',
    DROP_ELEMENTS: 'Elemente ablegen...',
    READONLY: 'Schreibgeschützt',
    CUSTOM_TITLE: 'Benutzerdefinierter Titel',
    SELECT_ROW_TO_DROP_ELEMENTS: 'Zeile auswählen, um Elemente abzulegen.',
    CANT_MOVE_ROW_INSIDE_SELF: 'Eine Zeile kann nicht in sich selbst verschoben werden.',
    CLEAR_ALL: 'Alles leeren',
    MIGRATE_TO_SHEET: 'Zu Tabellenblatt migrieren',
    CHOOSE_TIME_PERIOD: 'Bitte wählen Sie einen Zeitraum',
    NO_VARIABLE: 'Keine Variable',
    NO_ROWS_SELECTED: 'Keine Zeilen ausgewählt',
    STARTING_YEAR_NOT_ACTIVE: 'Startjahr nicht aktiv',
    SHEET: 'Tabellenblatt',
    ASSIGNEE: 'Zugewiesener',
    APPROVER: 'Genehmiger',
    SHARED_TO: 'Geteilt mit',
    PUBLIC: 'Öffentlich',
    PUBLIC_LINK: 'Öffentlicher Link',
    VERSIONS_AND_INTERVAL: 'Versionen & Intervall',
    INTERVAL: 'Intervall',
    EXPIRES_IN: 'Läuft ab in',
    STATUS: 'Status',
    STATUS_EXPIRES_IN: 'Status (läuft ab in)',
    PUBLIC_ASSIGNMENT_LINK_COPIED_TO_CLIPBOARD: 'Öffentlicher Aufgabenlink in die Zwischenablage kopiert',
    EXPORTING: 'Wird exportiert...',
    APPROVE: 'Genehmigen',
    DISAPPROVE: 'Ablehnen',
    EXPORT: 'Exportieren',
    EXPIRE: 'Ablaufen lassen',
    REFRESH: 'Aktualisieren',
    NO_ASSIGNMENTS_AVAILABLE: 'Keine Aufgaben verfügbar.',
    MARK_IN_REVIEW: 'Als in Überprüfung markieren',
    MARK_AS_UNRESOLVED: 'Als ungelöst markieren',
    MARK_AS_RESOLVED: 'Als gelöst markieren',
    GO_TO_ROW: 'Zur Zeile gehen',
    DELETE_THREAD: 'Thread löschen',
    REPLAY_OR_TAG_IN_COMMENT: 'Antworten oder andere mit @ markieren...',
    COMMENT_OF: 'Kommentar {arrowsCurrent} von {arrowsAll}',
    COMMENT: 'Kommentar',
    COMMENTS: 'Kommentare',
    LOADING_IMPORT_JOBS: 'Importaufträge werden geladen',
    IMPORT_ROWS_TRUNCATED_WARNING: 'Der Datensatz ist zu groß für eine vollständige Anzeige. Nur die ersten 200.000 Zeilen werden angezeigt. Alle Zeilen werden beim Festschreiben importiert.',
    SELECTED_JOB_DOESNT_EXIST: 'Ausgewählter Auftrag existiert nicht',
    GO_BACK_TO_IMPORT: 'Zurück zum Import',
    BACK_TO_IMPORT: 'Zurück zum Import',
    AT_LEAST_ONE_CHART_LINE: 'Sie müssen mindestens eine Diagrammlinie hinzufügen.',
    AT_LEAST_ONE_X_AXIS_TAG: 'Sie müssen mindestens einen X-Achsen-Tag hinzufügen',
    VISUALIZATION_TYPE: 'Visualisierungstyp',
    VISUALISATION_OPTIONS: 'Visualisierungsoptionen',
    EDIT_CHART: 'Diagramm "{title}" bearbeiten',
    BAR_CHART: 'Balkendiagramm',
    BAR: 'Balken',
    STACKED_BAR_CHART: 'Gestapeltes Balkendiagramm',
    STACKED_BAR: 'Gestapelter Balken',
    WATERFALL_CHART: 'Wasserfalldiagramm',
    WATERFALL: 'Wasserfall',
    PIN_CHART: 'Nadeldiagramm',
    PIN: 'Nadel',
    AREA_CHART: 'Flächendiagramm',
    AREA: 'Fläche',
    STACKED_AREA_CHART: 'Gestapeltes Flächendiagramm',
    STACKED_AREA: 'Gestapelte Fläche',
    LINE_CHART: 'Liniendiagramm',
    LINE: 'Linie',
    COMBO_CHART: 'Kombinationsdiagramm',
    PIE_CHART: 'Kreisdiagramm',
    TRAFFIC_LIGHT: 'Ampel',
    INDICATOR: 'Indikator',
    SINGLE_VALUE: 'Einzelwert',
    CREATE_CHART: 'Neues Diagramm erstellen',
    ORIENTATION_LAYOUT: 'Ausrichtung & Layout',
    HORIZONTAL: 'Horizontal',
    VERTICAL: 'Vertikal',
    SINGLE: 'Einzeln',
    GRID: 'Raster',
    THIN: 'Dünn',
    THICK: 'Dick',
    DOUBLE: 'Doppelt',
    DOT: 'Punkt',
    CIRCLE: 'Kreis',
    SQUARE: 'Quadrat',
    CATEGORY_AXIS: 'Kategorieachse',
    DOMAIN_AXIS: 'Domänenachse',
    SHOW_TOTALS: 'Summen anzeigen',
    SHOW_AXIS: 'Achse anzeigen',
    SHOW_VALUE_AXIS: 'Wertachse anzeigen',
    SHOW_CATEGORY_AXIS_LABELS: 'Kategorieachsenbeschriftungen anzeigen',
    LABEL_FORMAT: 'Beschriftungsformat',
    SHOW_LEGEND: 'Legende anzeigen',
    SHOW_INTEGRATED_LEGEND: 'Integrierte Legende anzeigen',
    VALUE_LABELS: 'Wertbeschriftungen',
    ROW_VALUE_LABELS: 'Zeilen-Wertbeschriftungen',
    SHOW_VALUE_LABELS: 'Wertbeschriftungen anzeigen',
    POSITION: 'Position',
    SMART_FILTERING: 'Intelligente Filterung',
    TRANSPOSE_DATA: 'Zeilen und Spalten transponieren',
    NORMALIZE_TO_PERCENT: 'Auf 100 % normalisieren',
    SHOW_EMPTY_ROWS: 'Leere Zeilen anzeigen',
    SHOW_EMPTY_COLUMNS: 'Leere Spalten anzeigen',
    GROUP_BY_PARENT_ROW: 'Nach übergeordneter Zeile gruppieren',
    ACCUMULATE_DATA: 'Laufende Summe berechnen',
    COLOR_BY_VALUE: 'Farbe basierend auf Wert',
    COLOR_BY_TREND: 'Farbe basierend auf Trend',
    COLOR_TOTALS_BY_VALUE: 'Summen nach Wert einfärben',
    USE_SHARED_SCALE: 'Gemeinsame Skala verwenden',
    STATIC: 'Statisch',
    BY_VALUE: 'Nach Wert',
    BY_TREND: 'Nach Trend',
    BAR_SPACING: 'Balkenabstand',
    GAP: 'Abstand',
    WIDTH: 'Breite',
    USE_DATA_FROM_DIMENSION_SLICERS: 'Daten von Dimensions-Slicern verwenden',
    X_AXIS_DIMENSION_BUILDER: 'X-Achsen-Dimensionsbauer',
    ADD_REMOVE_X_AXIS_COLUMN: 'X-Achsen-Spalte hinzufügen/entfernen',
    Y_AXIS_ITEMS: 'Y-Achsen-Elemente',
    ADD_CHART_LINE: 'Diagrammlinie hinzufügen',
    UNLOCK_HIERARCHY: 'Hierarchie entsperren',
    LOCK_HIERARCHY: 'Hierarchie sperren',
    MATERIALIZE: 'Materialisieren',
    MORE_OPTIONS: 'Weitere Optionen',
    LOCK_ROW: 'Zeile sperren',
    LOCK_COLUMN: 'Spalte sperren',
    PASTE: 'Einfügen',
    COPY: 'Kopieren',
    CUT: 'Ausschneiden',
    PASTE_ROWS: 'Zeile(n) einfügen',
    COPY_ROWS: 'Zeile(n) kopieren',
    CUT_ROWS: 'Zeile(n) ausschneiden',
    MOVING_ROWS: 'Zeilen werden verschoben...',
    PASTING_ROWS: 'Zeilen werden eingefügt...',
    CONFIRM_LOCK: 'Sperre bestätigen',
    CONFIRM_UNLOCK: 'Entsperren bestätigen',
    CONFIRM_LOCK_AND_CHILDREN: 'Sind Sie sicher, dass Sie diese Zeile und ihre Unterelemente sperren möchten?',
    CONFIRM_UNLOCK_AND_CHILDREN: 'Sind Sie sicher, dass Sie diese Zeile und ihre Unterelemente entsperren möchten?',
    SEARCH_FOR_IMPORTS: 'Nach Importen suchen',
    NEW_IMPORT: 'Neuer Import',
    IMPORTER: 'Importer',
    CREATION_DATE: 'Erstellungsdatum',
    ACTIONS: 'Aktionen',
    ADD_ACTION: 'Aktion hinzufügen',
    ADD_ARGUMENT: 'Argument hinzufügen',
    EDIT_ACTION: 'Aktion bearbeiten',
    ACTION_NAME: 'Aktionsname',
    ARCHIVE: 'Archiv',
    REPLACE: 'Ersetzen',
    STATUS_MESSAGE_MAP: {
        'In progress': 'In Bearbeitung',
        Commited: 'Festgeschrieben',
        Archived: 'Archiviert',
        Reverted: 'Zurückgesetzt',
    },
    EDIT_TILE: 'Kachel bearbeiten',
    FOCUS_TILE: 'Kachel fokussieren',
    UNFOCUS_TILE: 'Kachelfokus aufheben',
    MOVE_TO: 'Verschieben nach',
    ADD_ROW: 'Zeile hinzufügen',
    ADD_COLUMN: 'Spalte hinzufügen',
    EDIT_ROW: 'Zeile bearbeiten',
    FROM: 'Von',
    TO: 'Bis',
    GLOBAL_FORMATTING: 'Globale Formatierung',
    FAIL_SAVE_CHANGES: 'Änderungen konnten nicht gespeichert werden.',
    TAG_NAME_EXISTS: 'Tag-Name existiert bereits.',
    MUST_CHOOSE_TYPE: 'Sie müssen einen Typ auswählen',
    MUST_ENTER_TAG_NAME: 'Sie müssen einen Namen für den Tag eingeben',
    TAG_NAME_CANT_CONTAIN_QUOTATION_MARKS: 'Tag-Name darf keine Anführungszeichen enthalten.',
    INVALID_VARIABLE_TAG_FORMAT: 'Ungültiges Variablen-Tag-Format: {tagFormat}',
    INVALID_FORMULA: 'Ungültige Formel.',
    FUNCITON_NOT_ALLOWED_ON_DIMENSION_TAGS: 'Funktion {image} ist für Dimensions-Tags nicht erlaubt.',
    CREATE_DATABASE_OBJECT: 'Datenbankobjekt erstellen',
    EDIT_TAG_TYPE_NAME: '{tagType} "{tagName}" bearbeiten',
    PARENT: 'Übergeordnet',
    ROOT: 'Wurzel',
    SEARCH_OR_SELECT_PARENT_TAG: 'Übergeordneten Tag suchen oder auswählen',
    ROLLUP_TYPE: 'Zusammenfassungstyp',
    DATA_TYPE: 'Datentyp',
    FORMAT_TYPE: 'Formattyp',
    CHOOSE_FORMATTING_OPTION: 'Formatierungsoption auswählen',
    ENTER_CUSTOM_FORMAT: 'Benutzerdefiniertes Format eingeben',
    CUSTOM_FORMAT: 'Benutzerdefiniertes Format',
    TOP_DOWN: 'Top-Down',
    TOP_DOWN_DATA_MAPPING: 'Top-Down-Datenzuordnung',
    CONNECTED: 'Verbunden',
    ADD_CONNECTED_VARIABLE: 'Verbundene Variable hinzufügen',
    REVERSE_CONNECTED: 'Umgekehrt verbunden',
    ADD_REVERSE_CONNECTED_VARIABLE: 'Umgekehrt verbundene Variable hinzufügen',
    DIMENSIONS: 'Dimensionen',
    ADD_DIMENSION: 'Dimension hinzufügen',
    ADVANCED: 'Erweitert',
    CALCULATE_ON_DEMAND: 'Auf Anfrage berechnen',
    TRIGGER_ON_DEMAND_CALCULATION: 'Für die On-Demand-Berechnung gehen Sie zu "Eingabeeinstellungen"',
    OPTIMIZE_CALCULATION: 'Berechnung optimieren',
    CONSTRAINED_LIGHT_TOP_DOWN: 'Eingeschränkter leichter Top-Down',
    USE_HIERARCHY_IN_CALCULATION: 'Hierarchie in der Berechnung verwenden',
    MAPPING_TO_VARIABLE: 'Zuordnung zur Variable',
    ADD_FROM_VERSION: 'Von Version hinzufügen',
    MAPPING_FROM_VERSION: 'Zuordnung von Version',
    MAPPING_TO_VERSION: 'Zuordnung zu Version',
    ADD_TO_VERSION: 'Zu Version hinzufügen',
    USED_IN_FORMULA: 'Verwendet in 1 Formel',
    USED_IN_FORMULAS: 'Verwendet in {numberOfTags} Formeln',
    TABLE_BACKLINKS: 'Referenziert von {{1 Tabelle|?? Tabellen}}',
    VARIABLE_BACKLINKS: 'Verwendet von {{1 Variable|?? Variablen}}',
    ACTIVE: 'Aktiv',
    CONNECTED_DIMENSION: 'verbundene Dimension',
    MY_ACCOUNT: 'Mein Konto',
    SIGN_OUT: 'Abmelden',
    LOG_OUT: 'Abmelden',
    EDIT_PROFILE: 'Profil bearbeiten',
    FARSEER_AI: 'FarseerAI',
    FARSEER_LABS: 'Farseer Labs',
    PROFILE_AND_SUPPORT: 'Profil & Support',
    RENAME_TABLE: 'Tabelle umbenennen',
    SHARE_TABLE: 'Tabelle teilen',
    DELETE_TABLE_DATA: 'Tabellendaten löschen',
    DELETE_TABLE_MEMBERS: 'Tabellenmitglieder löschen',
    DELETE_TABLE_DIMENSIONS: 'Tabellendimensionen löschen',
    DELETE_TABLE: 'Tabelle löschen',
    DELETE_ROW: 'Zeile löschen',
    DELETE_ROWS: 'Zeile(n) löschen',
    SHOW_VALUE: 'Wert anzeigen',
    SHOW_VARIABLES_AND_DIMENSIONS: 'Variablen und Dimensionen anzeigen',
    FREEZE_ROW_COLUMNS: 'Zeilen/Spalten einfrieren',
    HIDE_GRIDLINES: 'Gitterlinien ausblenden',
    HIDE_ROW_COLUMN_HEADERS: 'Zeilen-/Spaltenüberschriften ausblenden',
    LABELS: 'Bezeichnungen',
    ADD_LABEL: 'Bezeichnung hinzufügen',
    ERROR_LABEL_EXISTS: 'Bezeichnung existiert bereits!',
    ERROR_RENAMING_IMPORT_JOB_LABEL: 'Fehler beim Umbenennen der Importauftrags-Bezeichnung!',
    IMPORT_JOB_LABEL_RENAMED: 'Importauftrags-Bezeichnung umbenannt',
    ERROR_DELETING_IMPORT_JOB_LABEL: 'Fehler beim Löschen der Importauftrags-Bezeichnung!',
    IMPORT_JOB_LABEL_DELETED: 'Importauftrags-Bezeichnung gelöscht',
    CREATE_OR_SEARCH: 'Erstellen oder suchen...',
    CREATE: 'Erstellen',
    NAME_AND_DESCRIPTION: 'Name und Beschreibung',
    SUBTOTALS: 'Zwischensummen',
    TOTAL: 'Gesamt',
    DISABLED: 'Deaktiviert',
    BEFORE: 'Vorher',
    AFTER: 'Nachher',
    UNSELECT_ALL: 'Alle abwählen',
    SAVE_CONFIG_FOR_ALL: 'Konfiguration für alle speichern',
    SAVE_CONFIG_FOR_ALL_TOOLTIP: 'Speichert den aktuellen Finder-Status, Filter, Zeitleiste & Tabellenblattoptionen als Standardkonfiguration.',
    EDIT_DIMENSION_SLICER: 'Dimensions-Slicer "{title}" bearbeiten',
    CREATE_DIMENSION_SLICER: 'Neuen Dimensions-Slicer erstellen',
    ENABLE_MULTISELECT: 'Mehrfachauswahl aktivieren',
    DISPLAY_MULTIPLE_VALUES: 'Mehrere Werte anzeigen',
    SEARCH_AND_AUTO_SELECT: 'Suchen & automatisch auswählen',
    BLANKS: '(Leer)',
    ENTER_TITLE: 'Titel eingeben...',
    TAG_NAME_DISPLAY: 'Tag-Namensanzeige',
    FILTERS: 'Filter',
    ADD_FILTER: 'Filter hinzufügen',
    BY_DIMENSION: 'Nach Dimension',
    SHOW_ONLY_DIMENSIONS_WITH_DATA_IN: 'Nur Dimensionen mit Daten anzeigen in...',
    EDIT_SINGLE_VALUE: 'Einzelwert "{title}" bearbeiten',
    CREATE_SINGLE_VALUE: 'Neuen Einzelwert erstellen',
    LEAVE_EMPTY_FOR_AUTOGENERATED: 'Leer lassen für automatische Generierung',
    FILTER_DIMENSIONS: 'Dimensionen filtern',
    COMPARISON_DIMENSIONS: 'Vergleichsdimensionen',
    COMPARISON_CUSTOM_TEXT: 'Benutzerdefinierter Vergleichstext',
    DATA_ENTRY: 'Dateneingabe',
    SHOW_BUTTONS: 'Schaltflächen anzeigen',
    STEP: 'Schritt',
    AND: 'und',
    DOWNSTREAM_FILTERS: 'Nachgeschaltete Filter',
    TO_TABLE: 'Zur Tabelle',
    FROM_TABLE: 'Von Tabelle',
    ADD_DOWNSTREAM_FILTER: 'Nachgeschalteten Filter hinzufügen',
    FLAT: 'Flach',
    HIERARCHY_MAX_DEPTH: 'Maximale Hierarchietiefe',
    APPLICATION_VERSION: 'Anwendungsversion',
    CONFIRM_TAG_REMOVE: 'Tag-Entfernung bestätigen',
    CONFIRM_TAGS_REMOVE: 'Tags-Entfernung bestätigen',
    REMOVE_TAG_CONFIRMATION: 'Sind Sie sicher, dass Sie den Tag {tagName} entfernen möchten?',
    REMOVE_TAGS_CONFIRMATION: 'Sind Sie sicher, dass Sie die Tags {tagNames} entfernen möchten?',
    REMOVE_TAGS_NUMBER_CONFIRMATION: 'Sind Sie sicher, dass Sie {tagNumber} Tags entfernen möchten?',
    ERROR_PARSING_NUMBER: 'Fehler beim Parsen der Zahl',
    ERROR_PARSING_DATE: 'Fehler beim Parsen des Datums',
    USE_CONTEXT_MENU_FOR_UPDATING_FILE_COLUMN: 'Bitte verwenden Sie das Kontextmenü zum Aktualisieren der Dateispalte',
    ERROR_PARSING_INPUT_NUMBER: 'Fehler beim Parsen der Eingabenummer',
    ERROR_SAVING_DATA: 'Fehler beim Speichern der Daten',
    DATA_ENTRY_NOT_ALLOWED: 'Dateneingabe nicht erlaubt',
    ERROR_PARSING_STEP_VALUE: 'Fehler beim Parsen des Schrittwerts',
    TAG_NAME_CELLS: '{tagName}: {cellNumber} Zellen',
    UNKNOWN_VARIABLE_CELLS: 'Unbekannte Variable: {cellNumber} Zellen',
    SUCCESS_IMPORTED_CELLS: 'Erfolgreich! Importierte Zellen: {accountTags}',
    IMPORTED_CELLS: 'Importierte Zellen',
    IMPORT_JOB_DELETING: 'Importauftrag wird gelöscht',
    IMPORT_JOB_DELETING_CONFIRM: 'Sind Sie sicher, dass Sie den Importauftrag {importJobName} löschen möchten?',
    DELETE_AND_KEEP_DATA: 'Löschen & Daten behalten',
    DELETE_JOB_AND_DATA: 'Auftrag und Daten löschen',
    ADD_DIMENSIONS_TO_JOB: 'Dimensionen zum Auftrag hinzufügen',
    CONFIGURE: 'Konfigurieren',
    ADD_DESCRIPTION_FOR_IMPORT: 'Beschreibung für diesen Import hinzufügen',
    UNDO: 'Rückgängig',
    SETTINGS: 'Einstellungen',
    BASIC_SETTINGS: 'Grundeinstellungen',
    OTHER_SETTINGS: 'Weitere Einstellungen',
    TABLE_NAME: 'Tabellenname',
    AUTOGENERATE_DIMENSION_NAMES: 'Dimensionsnamen automatisch generieren',
    AUTOGENERATE_NAMES_CONFIG: 'Konfiguration für automatische Namensgenerierung',
    AUTOGENERATE_NAMES_CONFIG_EXAMPLE: 'z. B. {SSS}-{YY}#{DD}',
    CUSTOM_TEMPLATE_DESCRIPTION: 'Definieren Sie eine benutzerdefinierte Konfiguration zur automatischen Namensgenerierung für diese Tabelle. Verwenden Sie die vordefinierten Token unten mit geschweiften Klammern. Sie können beliebige Zeichen zwischen den Token platzieren.',
    USE_TOKENS_TO_DEFINE_CONFIG: 'Sie können diese Token verwenden, um Ihre Konfiguration zu definieren',
    AUTOGENERATE_CONFIG_EXAMPLE: '{SSS}-{YY}#{MM}_{DD}',
    AUTOGENERATE_CONFIG_EXAMPLE_DATE: '- 001-23#03_20 (20. März 2023)',
    ENTRY: 'Eintrag',
    STEP_MUST_BE_NUMBER: 'Schritt muss eine Zahl sein.',
    EDIT_DATA_EDITOR: 'Dateneditor "{title}" bearbeiten',
    BUTTON_CONTROLS: 'Schaltflächensteuerung',
    BOLD: 'Fett',
    ITALIC: 'Kursiv',
    UNDERLINED: 'Unterstrichen',
    OUTLINED: 'Umriss',
    FONT_SIZE: 'Schriftgröße',
    FILE_SIZE: 'Dateigröße',
    SMALL: 'Klein',
    MEDIUM: 'Mittel',
    LARGE: 'Groß',
    CREATE_NEW_COLUMN: 'Neue Spalte erstellen',
    EDIT_COLUMN_WITH_LABEL: 'Spalte "{label}" bearbeiten',
    COLUMN_TAGS: 'Spalten-Tags',
    DELETE_THIS_COLUMN: 'Diese Spalte löschen',
    SELECT_PARENT_TAG_TO_GENERATE_COLUMNS: 'Übergeordneten Tag auswählen, um mehrere Spalten zu generieren',
    USING_SHARED_COLUMN_CONFIG: 'Gemeinsame Spaltenkonfiguration wird verwendet',
    SLICER_GENERATED: 'Slicer generiert',
    HEADER_CANNOT_BE_EMPTY: 'Kopfzeile darf nicht leer sein',
    MUST_CHOOSE_A_FORMAT: 'Sie müssen ein Format auswählen',
    CALCULATION_FIELDS_CANT_BE_EMPTY: 'Berechnungsfelder dürfen nicht leer sein',
    ADD_NEW_COLUMN: 'Neue Spalte hinzufügen',
    HEADER: 'Kopfzeile',
    SUBHEADER: 'Unterkopfzeile',
    TYPE: 'Typ',
    POLARITY: 'Polarität',
    CONDITIONAL_FORMATTING: 'Bedingte Formatierung',
    CONDITIONAL_FORMATTING_TYPE_OPTIONS: {
        Relative: 'Relativ',
        Absolute: 'Absolut',
    },
    CONDITIONAL_FORMATTING_POLARITY_OPTIONS: {
        Positive: 'Positiv',
        Negative: 'Negativ',
        Neutral: 'Neutral',
    },
    KPI_COLUMN_TYPE_META: {
        Regular: 'Standard',
        Calculated: 'Berechnet',
    },
    CONDITIONAL_FORMATTING_OPTIONS: {
        Off: 'Aus',
        Traffic: 'Ampel',
        Databar: 'Datenbalken',
        Colorscale: 'Farbskala',
        Arrows: 'Pfeil auf und ab',
    },
    HIDE_NUMBERS: 'Zahlen ausblenden',
    COLUMN_ONE: 'Spalte 1',
    COLUMN_TWO: 'Spalte 2',
    LITERAL: 'Literal',
    FUNCTION: 'Funktion',
    FUNCTIONS: 'Funktionen',
    EXAMPLE: 'Beispiel',
    EDIT_IN: '{type} bearbeiten',
    OPEN_IN_EDITOR: 'Im {type}-Editor öffnen',
    REMOTE_JOBS_DATE_TIME_MESSAGE: 'Jede Woche am {day} um {time}',
    REMOTE_JOB_SCHEDULED: 'Geplant {schedule}',
    SCHEDULE: 'Zeitplan',
    EVERY: 'Alle',
    EVERY_HOUR_AT: 'Jede Stunde um',
    EVERY_DAY_AT: 'Jeden Tag um',
    RUN_JOB: 'Auftrag ausführen',
    RUN: 'Ausführen',
    QUEUED: 'In Warteschlange',
    RUNNING: 'Wird ausgeführt...',
    UNAVAILABLE: 'Nicht verfügbar',
    MINUTES: 'Minuten',
    JOBS: 'Aufträge',
    JOB_LOGS: 'Auftragsprotokolle',
    PREFERRED_RUNNER: 'Bevorzugter Runner',
    RUNNER_DISCONNECTED: 'Dieser Runner ist derzeit nicht verbunden.',
    RUNNER_IMAGE: 'Runner-Image',
    RUNNER_IMAGE_TAG: 'Version',
    LOGS: 'Protokolle',
    REMOTE_JOBS: 'Apps',
    TAG_INTERNAL_TYPE_NAME: {
        Version: 'Version',
        Year: 'Jahr',
        Month: 'Monat',
        Quarter: 'Quartal',
        'Half Year': 'Halbjahr',
        'Year to Date': 'Jahr bis dato',
    },
    VARIABLE_TABLE_DIMENSION_GROUP: 'Variable/Tabelle/Dimension/Gruppe',
    ADD_NEW_VARIABLE_TABLE_DIMENSION_GROUP: 'Neue {item} hinzufügen',
    DATA_TYPE_ENUM: {
        Integer: 'Ganzzahl',
        Decimal: 'Dezimalzahl',
    },
    DEFAULT_FORMAT_TYPE_ENUM: {
        Custom: 'Benutzerdefiniert',
        Number: 'Zahl',
        Currency: 'Währung',
        Percentage: 'Prozent',
        Date: 'Datum',
    },
    HEADER_NAVIGATION: {
        Dashboard: 'Dashboard',
        Sheets: 'Tabellenblätter',
        Import: 'Import',
        'Remote jobs': 'Apps',
        Dimensions: 'Dimensionen',
    },
    ENTITY_TYPE: {
        DIMENSION_TABLE: 'Dimensionstabelle',
        DIMENSION_MEMBER: 'Dimensionsmitglied',
        VARIABLE: 'Variable',
        FOLDER: 'Ordner',
        FUNCTION: 'Funktion',
        LITERAL: 'Literal',
        PROPERTY: 'Eigenschaft',
        FILE: 'Datei',
        DASHBOARD: 'Dashboard',
        REMOTE_JOB: 'App',
        SHEET: 'Tabellenblatt',
        TILE: 'Kachel',
    },
    ENTITY_TYPES: {
        DIMENSION_TABLE: 'Dimensionstabellen',
        DIMENSION_MEMBER: 'Dimensionsmitglieder',
        VARIABLE: 'Variablen',
        FOLDER: 'Ordner',
        FUNCTION: 'Funktionen',
        LITERAL: 'Literale',
        PROPERTY: 'Eigenschaften',
        FILE: 'Dateien',
        DASHBOARD: 'Dashboards',
        REMOTE_JOB: 'Apps',
        SHEET: 'Tabellenblätter',
        TILE: 'Kacheln',
    },
    ITEM: 'Element',
    ITEM_TYPE: 'Elementtyp',
    FOLDER_ITEM: {
        DASHBOARD: 'Dashboard',
        DIMENSION_TABLE: 'Dimensionstabelle',
        VARIABLE: 'Variable',
        SHEET: 'Tabellenblatt',
        FOLDER: 'Ordner',
        FARSEER_FILE: 'Datei',
        REMOTE_JOB: 'App',
    },
    FOLDER_ITEMS: {
        DASHBOARD: 'Dashboards',
        DIMENSION_TABLE: 'Dimensionstabellen',
        VARIABLE: 'Variablen',
        SHEET: 'Tabellenblätter',
        FOLDER: 'Ordner',
        FARSEER_FILE: 'Dateien',
        REMOTE_JOB: 'Apps',
    },
    TABLE_SETTINGS_TEMPLATE_PATTERNS: {
        UUID: 'generiert einen universell eindeutigen Bezeichner',
        YYYY: 'fügt das aktuelle Jahr ein',
        YY: 'fügt die letzten zwei Ziffern des aktuellen Jahres ein (Kurzjahr)',
        MM: 'fügt den aktuellen Monat ein',
        DD: 'fügt den aktuellen Tag ein',
        SSSSSSSS: 'fügt die Seriennummer aus der aktuellen Tabellenkinderanzahl + 1 ein, definieren Sie die Länge durch die Anzahl der "S"-Zeichen (1-8)',
    },
    CONFIG_MENU_SECTIONS: {
        'Users & Permissions': 'Benutzer & Berechtigungen',
        'Users & Groups': 'Benutzer & Gruppen',
        System: 'System',
        'Input Setup': 'Eingabeeinstellungen',
        Locks: 'Sperren',
        'Backup & Restore': 'Sicherung & Wiederherstellung',
        'Audit Logs': 'Auditprotokolle',
        'Export Model': 'Modell exportieren',
        'Import Model': 'Modell importieren',
        'Switch Tenants': 'Arbeitsbereich wechseln',
        Support: 'Support',
        'Help Center': 'Hilfecenter',
        'Contact Support': 'Support kontaktieren',
    },
    KPI_COLUMN_OPERATIONS: {
        minus: 'Minus',
        divide: 'Dividieren',
        plus: 'Plus',
        multiply: 'Multiplizieren',
        percent: 'Prozent',
        'percent thousands': 'Prozent Tausende',
        'difference in %': 'Differenz in %',
    },
    STATUS_MAP: {
        Resolved: 'Gelöst',
        Unresolved: 'Ungelöst',
        'In Review': 'In Überprüfung',
        QUEUED: 'IN WARTESCHLANGE',
        RUNNING: 'WIRD AUSGEFÜHRT',
        FINISHED: 'ABGESCHLOSSEN',
        ERROR: 'FEHLER',
    },
    USER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create User': 'Benutzer erstellen',
        'Delete User': 'Benutzer löschen',
        'Find All Users': 'Alle Benutzer finden',
        'Get User': 'Benutzer abrufen',
        'Update User': 'Benutzer aktualisieren',
    },
    FEATURE_PERMISSIONS_TITLE_MAP: {
        TAGS_IN_MODEL: 'Zeilen-/Spaltenwerkzeugleiste',
        CLUSTER_FLOW_ADD: 'Zeile hinzufügen',
        YEAR_VERSION_LOCKS: 'Sperren',
        IMPORT: 'Import',
        SEE_ALL_IMPORT_JOBS: 'Alle Importaufträge anzeigen',
        USERS_GROUPS_MANAGEMENT: 'Benutzer- & Gruppenverwaltung',
        REMOTE_JOBS: 'Apps',
        COMMENTS: 'Kommentare',
        TAGS_SIDEBAR: 'Datenbank-Seitenleiste',
        CREDENTIALS: 'Anmeldedaten',
        INPUT_SETUP: 'Eingabeeinstellungen',
        AUDIT_LOGS: 'Auditprotokolle anzeigen',
        ASSIGNMENTS: 'Aufgaben',
        BACKUP_AND_RESTORE: 'Sicherung & Wiederherstellung',
        DASHBOARD_TO_IMAGE: 'Dashboard als Bild',
        CHAT_AI: 'Chat-KI',
        DELETE_DIMENSION: 'Dimension löschen',
        FORECAST: 'Prognose',
        GOAL_SEEKING_TOP_DOWN: 'Zielwertsuche Top-Down',
        MODEL_IMPEX: 'Modell-Import/Export',
        OWD_MEASURES: 'Nur mit Daten für Kennzahlen',
        FORMULA_QA: 'Formel-QA',
        USE_HIERARCHY_IN_CALCULATION: '"Hierarchie verwenden" in Variablen aktualisieren',
        MODEL_HEALTH: 'Modellzustand',
        FARSEER_LABS: 'Farseer Labs',
        FARSEER_LOGO: 'Farseer-Logo',
    },
    CELL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Edit Cells': 'Zellen bearbeiten',
    },
    FOLDER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Folder': 'Ordner erstellen',
        'Duplicate Folder': 'Ordner duplizieren',
        'Search Folders': 'Ordner durchsuchen',
        'Get Items in Folder': 'Elemente im Ordner abrufen',
        'Find by Reverse References': 'Nach Rückverweisen suchen',
        'Move Items': 'Elemente verschieben',
        'Rename Items': 'Elemente umbenennen',
        'Delete Items in Folder': 'Elemente im Ordner löschen',
        'Share Folder Hierarchy': 'Ordnerhierarchie teilen',
    },
    TAG_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Database Object': 'Datenbankobjekt erstellen',
        'Delete Database Object': 'Datenbankobjekt löschen',
        'Get Database Object': 'Datenbankobjekt abrufen',
        'Update Database Object': 'Datenbankobjekt aktualisieren',
        'Search Database Objects': 'Datenbankobjekte durchsuchen',
    },
    SHEET_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Sheet': 'Tabellenblatt erstellen',
        'Get Sheet': 'Tabellenblatt abrufen',
        'Update Sheet': 'Tabellenblatt aktualisieren',
        'Duplicate Sheet': 'Tabellenblatt duplizieren',
        'Search Rows in Sheet': 'Zeilen im Tabellenblatt suchen',
        'Get Sheet Data': 'Tabellenblattdaten abrufen',
        'Set Sheet Data': 'Tabellenblattdaten setzen',
    },
    SHEET_ROW_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Row': 'Zeile erstellen',
        'Update Row': 'Zeile aktualisieren',
        'Delete Row': 'Zeile löschen',
        'Move Row': 'Zeile verschieben',
        'Duplicate Row': 'Zeile duplizieren',
        'Find All Row': 'Alle Zeilen finden',
        'Get Row': 'Zeile abrufen',
        'Materialize Row': 'Zeile materialisieren',
    },
    SHARE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Share': 'Freigabe erstellen',
        'Add Public Shares': 'Öffentliche Freigaben hinzufügen',
        'Delete Share': 'Freigabe löschen',
        'Get Share': 'Freigabe abrufen',
        'Update Share': 'Freigabe aktualisieren',
    },
    LABEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Get Label': 'Bezeichnung abrufen',
        'Create Label': 'Bezeichnung erstellen',
        'Update Label': 'Bezeichnung aktualisieren',
        'Delete Label': 'Bezeichnung löschen',
    },
    FARSEER_FILE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create File': 'Datei erstellen',
        'Update File': 'Datei aktualisieren',
        'Delete File': 'Datei löschen',
        'Find All Files': 'Alle Dateien finden',
        'Get File': 'Datei abrufen',
    },
    REMOTE_JOB_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Remote Job': 'App erstellen',
        'Update Remote Job': 'App aktualisieren',
        'Find All Remote Jobs': 'Alle Apps finden',
        'Get Remote Job': 'App abrufen',
        'Run Remote Job': 'App ausführen',
        'Run Remote Job As A Service': 'App als Dienst ausführen',
    },
    OVERSEER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Restore Backup': 'Sicherung wiederherstellen',
        'Create Backup': 'Sicherung erstellen',
        'Search Backups': 'Sicherungen durchsuchen',
        'Download Backup': 'Sicherung herunterladen',
        'Upload Backup': 'Sicherung hochladen',
    },
    MODEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Read Model': 'Modell lesen',
        'Edit Model': 'Modell bearbeiten',
    },
    DASHBOARD_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Dashboard': 'Dashboard erstellen',
        'Duplicate Dashboard': 'Dashboard duplizieren',
        'Find All Dashboards': 'Alle Dashboards finden',
        'Get Dashboard': 'Dashboard abrufen',
        'Update Dashboard': 'Dashboard aktualisieren',
    },
    FEATURE_PERMISSION_TITLES: {
        FeaturePermission: 'Funktionsberechtigung',
        FolderClassPermission: 'Ordner-Klassenberechtigung',
        TagClassPermission: 'Tag-Klassenberechtigung',
        SheetClassPermission: 'Tabellenblatt-Klassenberechtigung',
        SheetRowClassPermission: 'Tabellenblattzeilen-Klassenberechtigung',
    },
    SEARCH_TAGS: 'Tags durchsuchen...',
    SEARCH_PERMISSIONS: 'Nach Berechtigungen suchen...',
    DEFAULT: 'Standard',
    FEATURE_PERMISSIONS: 'Funktionsberechtigungen',
    CLASS_PERMISSIONS: 'Klassenberechtigungen',
    ADD_COMMENT: 'Kommentar hinzufügen',
    SORT: 'Sortieren',
    SORT_BY: 'Sortieren nach',
    ASCENDING: 'Aufsteigend',
    DESCENDING: 'Absteigend',
    UNSORT: 'Sortierung aufheben',
    AUTO: 'Auto',
    LEFT: 'Links',
    ALL_MONTHS: 'Alle Monate',
    TWELVE_MONTHS: '12 Monate',
    YEAR_START: 'Jahresanfang',
    TIMELINE_START: 'Zeitleistenanfang',
    COPY_HASH_TAG: '# kopieren',
    SHOW_TOP: 'Oberste anzeigen',
    SHOW_REST: 'Rest anzeigen',
    RIGHT: 'Rechts',
    CENTER: 'Mitte',
    TOP: 'Oben',
    MIDDLE: 'Mitte',
    BOTTOM: 'Unten',
    YEAR_END: 'Jahresende',
    TIMELINE_END: 'Zeitleistenende',
    CURRENT_YEAR: 'Aktuelles Jahr',
    PREVIOUS_YEAR: 'Vorheriges Jahr',
    CUSTOM: 'Benutzerdefiniert',
    NEW_TABLE: 'Neue {name}',
    EDIT_TABLE: '{name} bearbeiten',
    FOCUS_TABLE: '{name} fokussieren',
    ROUND: 'Runden',
    REGRESSION: 'Regression',
    RANDOM: 'Zufällig',
    SET_VALUE: 'Wert setzen',
    APPLY_PERCENTAGE: 'Prozentsatz anwenden',
    APPLY_PERCENTAGE_CHAR: '% anwenden',
    DELETE_COLUMNS_ON_ROW: 'Spalten in Zeile löschen',
    PROCESSING_FILE: 'Datei wird verarbeitet',
    IMAGE_PREVIEW_FAILED: 'Bildvorschau nicht möglich',
    NEXT: 'Weiter',
    PREVIOUS: 'Zurück',
    PAGE_OF: 'Seite {pageNumber} von {pages}',
    NO_TITLE: 'Kein Titel',
    DURATION: 'Dauer',
    CELL_COUNT: 'Zellenanzahl',
    NONCALCULATED: 'Nicht berechnet',
    CALCULATED: 'Berechnet',
    SEARCH_ASSIGNMENTS: 'Aufgaben durchsuchen',
    BY_NAME: 'Nach Name',
    BY_LABEL: 'Nach Bezeichnung',
    BY_STATUS: 'Nach Status',
    BY_SHEET: 'Nach Tabellenblatt',
    GROUP_BY: 'Gruppieren nach',
    CHART_SPACING: 'Diagrammabstand',
    GRID_COLUMNS: 'Rasterspalten',
    GRID_SPACING: 'Rasterabstand',
    AXIS_SPACING: 'Achsenabstand',
    RESET_FILTERS: 'Filter zurücksetzen',
    RESET_CONFIG: 'Konfiguration zurücksetzen',
    RESET_CONFIG_TOOLTIP: 'Setzt den Finder-Status, Filter, Zeitleiste & Tabellenblattoptionen auf die Standardkonfiguration zurück.',
    BY_ASSIGNEE: 'Nach Zugewiesenem',
    BY_APPROVER: 'Nach Genehmiger',
    NEW_ASSIGNMENT: 'Neue Aufgabe',
    NEXT_ASSGN_DUE: 'Die nächste Aufgabe ist fällig am ',
    SHARE_SELECT_USER_PLACEHOLDER: 'Nach Benutzern oder Gruppen suchen...',
    CREATE_ASSIGNMENT_PLACEHOLDER: 'Benutzer für die Zuweisung zum Tabellenblatt suchen...',
    ASSIGNMENT_REFRESHED: 'Aufgabenfrist um 7 Tage verlängert',
    CANT_EDIT_ASSIGNMENT: 'Bereits eingereichte Aufgabe(n) können nicht bearbeitet werden',
    NO_CHANGES: 'Keine Änderungen',
    APPROVED: 'Genehmigt',
    EXPIRED: 'Abgelaufen',
    READY_FOR_REVIEW: 'Bereit zur Überprüfung',
    IN_PROGRESS: 'In Bearbeitung',
    SHARED: 'Geteilt',
    SHARED_WITH: 'Geteilt mit',
    ARCHIVED: 'Archiviert',
    STILL_STUCK: 'Immer noch Probleme? Besuchen Sie unser Hilfecenter.',
    NEED_HELP: 'Brauchen Sie Hilfe? Besuchen Sie unser Hilfecenter.',
    WELCOME: 'Willkommen',
    WELCOME_MESSAGE: 'Wählen Sie etwas aus der Seitenleiste, um zu beginnen, oder suchen Sie nach etwas Bestimmtem.',
    DEFAULT_MEMBER: 'Standardmitglied',
    FAILED_TO_LOAD_MODEL: 'Modell konnte nicht geladen werden',
    MODEL_LOADED: 'Modell geladen',
    PREVIOUS_MESSAGE_IS_PROCESSING: 'Ihre vorherige Nachricht wird verarbeitet. Bitte warten...',
    RUN_ARGUMENTS: 'Ausführungsargumente',
    EXPECTED_ARGUMENTS: 'Erwartete Argumente',
    RUN_ARGUMENTS_ERROR: 'Die Ausführungsargumente für die Aktion sind veraltet, bitte aktualisieren Sie diese.',
    GENERAL: 'Allgemein',
    SYSTEM: 'System',
    BASIC_INFO: 'Grundlegende Informationen',
    LAST_RUN: 'Letzte Ausführung',
    NEVER_RUN: 'Nie ausgeführt',
    REMOTE_JOB_NAME: 'App-Name',
    CHOOSE_FOLDER: 'Ordner auswählen',
    SOURCE_FOLDER: 'Quellordner',
    SELECT_SOURCE_FOLDER_WARNING: 'Bitte wählen Sie einen Quellordner',
    MAIN_FILE_HINT: 'Klicken Sie auf die Datei-Markierung, um die Skriptdatei als Einstiegspunkt festzulegen',
    NO_FILES: 'Keine Dateien',
    NO_MAIN_FILE: 'Keine Hauptdatei',
    FINDER_TOOLTIP: 'Finder anzeigen',
    VARIABLE_TOOLTIP: 'Variablenleiste anzeigen',
    sheet_ITEMS_TOOLTIP: 'Tabellenblattelemente anzeigen',
    LIST_ITEMS_TOOLTIP: 'Listenelemente anzeigen',
    EXPAND_TOOLTIP: 'Alle Zeilen um eine Ebene erweitern',
    COLLAPSE_TOOLTIP: 'Alle Zeilen um eine Ebene zusammenklappen',
    FORECAST_TOOLTIP: 'Prognosefortschritt anzeigen',
    EXPORT_TOOLTIP: 'Als .xlsx exportieren',
    APP_SHORTCUTS_TOOLTIP: 'App-Verknüpfungen',
    TAGS_SIDEBAR_TOOLTIP: 'Datenbankobjekte-Seitenleiste öffnen',
    TILE_SIDEBAR_TOOLTIP: 'Kachelbearbeitungs-Seitenleiste öffnen',
    COMMENTS_SIDEBAR_TOOLTIP: 'Kommentar-Seitenleiste öffnen',
    ADD_APP_SHORTCUT: 'Verknüpfung hinzufügen',
    APP_SHORTCUTS_PATH: 'App-Verknüpfungen',
    CHANGE_SHORTCUT_ACTION: 'Aktion ändern',
    REMOVE_SHORTCUT: 'Verknüpfung entfernen',
    SHORTCUT_ADDED: 'Verknüpfung erfolgreich hinzugefügt',
    SHORTCUT_REMOVED: 'Verknüpfung entfernt',
    SHORTCUT_ALREADY_EXISTS: 'Verknüpfung existiert bereits',
    CHANGE_ACTION_TITLE: 'Aktion ändern',
    CHANGE_ACTION_LABEL: 'Wählen Sie eine der folgenden Aktionen',
    ACTION_CHANGED: 'Aktion geändert',
    ERROR_FETCHING_APP_DATA: 'Fehler beim Abrufen der App-Daten',
    ERROR_FETCHING_ACTION_ARGUMENTS: 'Fehler beim Abrufen der Aktionsargumente',
    INVALID_ACTION_ARGUMENTS: 'Ungültige Aktionsargumente',
    APP_STARTED_SUCCESSFULLY: 'App erfolgreich gestartet',
    CREATE_BACKUP: 'Sicherung erstellen',
    BACKUP: 'Sicherung',
    CREATE_BACKUP_WARNING: 'Sind Sie sicher, dass Sie eine neue Sicherung erstellen möchten?',
    RESTORE_BACKUP: 'Sicherung wiederherstellen',
    RESTORE: 'Wiederherstellen',
    RESTORE_BACKUP_WARNING: 'Sind Sie sicher, dass Sie die Sicherung {backupPath} wiederherstellen möchten?',
    SELECT_MONTH: 'Monat auswählen',
    REMOVE_FILTER: 'Filter entfernen',
    FILTER_BY: 'Filtern nach...',
    STATIC_FILTER: 'Dieser Filter kann nicht geändert werden',
    SELECT_ROW_TO: 'Zeile auswählen, um ihre Variable anzuzeigen oder zu bearbeiten',
    EDIT_ARGUMENT: 'Argument bearbeiten',
    ARGUMENT_NAME: 'Argumentname',
    DATA_TYPE_STRING: 'Zeichenkette',
    DATA_TYPE_BOOLEAN: 'Boolean',
    DEFAULT_VALUE: 'Standardwert',
    ADD_OPTION: 'Option hinzufügen',
    OPTION_VALUE: 'Optionswert',
    DROPDOWN_OPTIONS_MUST_BE_UNIQUE: 'Optionen müssen eindeutig sein',
    DROPDOWN_OPTION_EMPTY: 'Option darf nicht leer sein',
    DROPDOWN_DEFAULT_AUTO_HINT: 'Kein Standardwert ausgewählt — beim Speichern wird die erste Option verwendet.',
    LOCKED_AT_RUN_TIME: 'Wert zur Laufzeit sperren',
    LOCKED_AT_RUN_TIME_TOOLTIP: 'Wenn aktiviert, können Benutzer beim Ausführen der App diesen Wert nicht überschreiben.',
    LOCKED_REQUIRES_DEFAULT: 'Ein gesperrtes Argument muss einen Standardwert haben',
    SECRET: 'Geheim',
    SECRET_TOOLTIP: 'Wert wird bei der Eingabe und in Protokollen maskiert',
    NAME_REQUIRED: 'Name ist erforderlich',
    BACKUP_CREATED: 'Sicherung erstellt',
    DOWNLOADING_BACKUP: 'Sicherung wird heruntergeladen',
    BACKUP_RESTORED: 'Sicherung wiederhergestellt',
    UPLOAD_BACKUP: 'Sicherung hochladen',
    UPLOADING: 'Wird hochgeladen',
    SHOW_UPLOADED: 'Hochgeladene anzeigen',
    INITIATED_BY: 'Gestartet von',
    SAVE_AS_IMAGE: 'Als Bild speichern',
    CREATING_AND_SAVING_IMAGE: 'Bild wird erstellt und in Dateien gespeichert...',
    IMAGE_SAVED: 'Bild gespeichert!',
    FAILED_TO_SAVE_IMAGE: 'Bild konnte nicht gespeichert werden.',
    GOAL_VALUE: 'Zielwert',
    CURRENT_VALUE: 'Aktueller Wert',
    PERCENTAGE_MET: '{percentage} % erreicht',
    UNFREEZE_CELLS: 'Werte freigeben',
    FREEZE_CELLS: 'Werte einfrieren',
    UNSET_GOAL: 'Wert als Ziel aufheben',
    SET_GOAL: 'Wert als Ziel setzen',
    INSPECT_VALUE: 'Wert untersuchen',
    EDITING_TILE: 'Kachel bearbeiten',
    NO_TILE_SELECTED: 'Bitte wählen Sie eine Kachel.',
    NO_TILE_OPTIONS: 'Keine Optionen verfügbar.',
    TILE_NAME: 'Kachelname',
    ENTER_TILE_NAME: 'Kachelnamen eingeben',
    USE_FILTERS_FROM: 'Filter aus verwenden',
    USE_SORT_FROM: 'Sortierung aus verwenden',
    USE_TIMELINE_FROM: 'Zeitachse aus verwenden',
    SHOW_TILE_SORT: 'Sortierung dieser Kachel anzeigen',
    SHOW_TILE_FILTERS: 'Filter dieser Kachel anzeigen',
    SHOW_TILE_TIMELINE: 'Zeitleiste dieser Kachel anzeigen',
    DASHBOARD: 'Dashboard',
    TILE: 'Kachel',
    CHART_COLUMN_OPTIONS: 'Spaltenoptionen',
    CHART_ROW_OPTIONS: 'Zeilenoptionen',
    GENERAL_STYLING: 'Allgemeine Gestaltung',
    PER_ROW_STYLING: 'Zeilengestaltung',
    PER_COLUMN_STYLING: 'Spaltengestaltung',
    TEXT_STYLE: 'Textstil',
    ROW_STYLE: 'Zeilenstil',
    COLOR: 'Farbe',
    PALETTE: 'Palette',
    BACKGROUND: 'Hintergrund',
    BORDER: 'Rahmen',
    SHADOW: 'Schatten',
    TOP_BORDER: 'Oberer Rahmen',
    BOTTOM_BORDER: 'Unterer Rahmen',
    INNER_BORDER: 'Innerer Rahmen',
    RESET_GENERAL_STYLES: 'Allgemeine Stile zurücksetzen',
    RESET_ALL_PER_ROW_STYLES: 'Alle Zeilenstile zurücksetzen',
    RESET_ALL_PER_COLUMN_STYLES: 'Alle Spaltenstile zurücksetzen',
    RESET_STYLES: 'Stile zurücksetzen',
    ADD_TABLE: 'Neue Dimensionstabelle',
    ADD_VARIABLE: 'Neue Variable',
    ADD_SHEET: 'Neues Tabellenblatt',
    ADD_DASHBOARD: 'Neues Dashboard',
    ADD_APP: 'Neue App',
    ADD_FILE: 'Neue Datei',
    ADD_FOLDER: 'Neuer Ordner',
    ENABLED: 'Aktiviert',
    NEW_TEMPLATE: 'Neue Vorlage',
    EDIT_TEMPLATE: 'Vorlage bearbeiten',
    SAVE_SELECTION_AS_TEMPLATE: 'Auswahl als Vorlage speichern',
    TEMPLATE_CREATED: 'Vorlage erstellt',
    TEMPLATE_UPDATED: 'Vorlage aktualisiert',
    TEMPLATE_DELETED: 'Vorlage gelöscht',
    TEMPLATE_NAME: 'Vorlagenname',
    TEMPLATE_DESCRIPTION: 'Vorlagenbeschreibung',
    QUANTITY: 'Menge',
    ENTER_TEXT: 'Text eingeben',
    ENTER_NUMBER: 'Zahl eingeben',
    PICK_A_DATE: 'Datum auswählen',
    ERROR_CREATING_DIMENSION: 'Fehler beim Erstellen einer neuen Dimension',
    ALLOW_MULTI_CREATE: 'Mehrere Elemente gleichzeitig erstellen erlauben',
    ALLOW_NAME_DESC_CONN_ON_CREATE: 'Name, Beschreibung und Verbindungen beim Erstellen festlegen',
    ALLOW_PROPERTIES_ON_CREATE: 'Eigenschaften beim Erstellen festlegen',
    NAMING_CONFIG_ENABLED: '(Namenskonfiguration aktiviert)',
    DIMENSION_TABLE: 'Dimensionstabelle',
    DIMENSION_TABLES: 'Dimensionstabellen',
    DIMENSION_MEMBER: 'Dimensionsmitglied',
    DIMENSION_MEMBERS: 'Dimensionsmitglieder',
    ASK_WHEN_CREATING: 'Beim Erstellen abfragen',
    PREDEFINED_CONNECTIONS: 'Vordefinierte Verbindungen',
    REQUIRED: 'Erforderlich',
    CHOOSE_A_TABLE_FIRST: 'Wählen Sie eine Dimensionstabelle, um die Verbindungen für diese Vorlage festzulegen.',
    BIND_TO_TIMELINE: 'An Zeitleiste binden',
    NEW_VARIABLE_COLUMN: 'Neue Variablenspalte',
    NEW_DIMENSION_COLUMN: 'Neue Dimensionsspalte',
    NEW_LOOKUP_COLUMN: 'Neue Lookup-Spalte',
    NEW_COMPARISON_COLUMN: 'Neue Vergleichsspalte',
    EDITING_CUSTOM_COLUMN: 'Benutzerdefinierte Spalte bearbeiten',
    LOOKUP_PROPERTIES: 'Lookup-Eigenschaften',
    CALCULATION_COLUMN: 'Berechnungsspalte',
    ADD_COLUMNS: 'Spalten hinzufügen',
    COLUMN_NAME: 'Spaltenname',
    DELETE_CUSTOM_COLUMN_CONFIRMATION: 'Sind Sie sicher, dass Sie diese Spalte löschen möchten?',
    AUTOGENERATED_CUSTOM_COLUMN_NAME: 'Leer lassen für einen automatisch generierten Namen',
    NOTE_INSPECT_VALUE: 'Hinweis: Die Funktion „Wert untersuchen" zeigt nur bis zu 500 Zeilen an. Um alle Daten zu sehen, exportieren Sie bitte den vollständigen Datensatz.',
    COPY_FROM: 'Kopieren von',
    PREVIEW: 'Vorschau',
    DECIMALS: 'Dezimalstellen',
    SIGNS: 'Vorzeichen',
    NEGATIVE_SIGNS: {
        SIGNED: 'Minus',
        UNSIGNED: 'Klammern',
        EXPLICIT: 'Plus/Minus',
    },
    POLARITY_SIGNS: {
        POSITIVE: 'Positiv',
        NEGATIVE: 'Negativ',
    },
    BASE_UNIT: 'Basiseinheit',
    BASE_UNITS: {
        ONES: 'Einer',
        THOUSANDS: 'Tausender',
        MILLIONS: 'Millionen',
        BILLIONS: 'Milliarden',
        AUTO: 'Automatisch',
    },
    CURRENCY_UNITS: {
        EUR: '€',
        USD: '$',
        HRK: 'HRK',
    },
    MONTHS: {
        January: 'Januar',
        February: 'Februar',
        March: 'März',
        April: 'April',
        May: 'Mai',
        June: 'Juni',
        July: 'Juli',
        August: 'August',
        September: 'September',
        October: 'Oktober',
        November: 'November',
        December: 'Dezember',
    },
    MONTHS_SHORT: {
        Jan: 'Jan',
        Feb: 'Feb',
        Mar: 'Mär',
        Apr: 'Apr',
        May: 'Mai',
        Jun: 'Jun',
        Jul: 'Jul',
        Aug: 'Aug',
        Sep: 'Sep',
        Oct: 'Okt',
        Nov: 'Nov',
        Dec: 'Dez',
    },
    DAYS: {
        Sunday: 'Sonntag',
        Monday: 'Montag',
        Tuesday: 'Dienstag',
        Wednesday: 'Mittwoch',
        Thursday: 'Donnerstag',
        Friday: 'Freitag',
        Saturday: 'Samstag',
    },
    DAYS_SHORT: {
        Sun: 'So',
        Mon: 'Mo',
        Tue: 'Di',
        Wed: 'Mi',
        Thu: 'Do',
        Fri: 'Fr',
        Sat: 'Sa',
    },
    CURRENCY: 'Währung',
    SIGNING_IN: 'Anmeldung läuft...',
    NEW_RELATION_COLUMN: 'Neue Verknüpfungsspalte',
    SELECT_TABLE_LOOKUP: 'Tabelle zum Nachschlagen auswählen',
    SELECT_TABLE_RELATION: 'Zeilenmitglieder verknüpfen mit',
    SELECT_TABLE_PROPERTY: 'Eigenschaft aus Tabelle auswählen',
    DISPLAY_TABLE_PROPERTY: 'Eigenschaft aus Tabelle anzeigen',
    FILTER_MEMBERS: 'Mitgliederauswahl mit Tabellenblattfiltern filtern',
    TABLE_RELATION: 'Tabellenverknüpfung',
    FILTER_DISPLAY: 'Anzeige filtern',
    RELATE_TABLE: 'Mit Tabelle verknüpfen',
    USE_BLANKS: 'Leerwerte verwenden',
    NO_DATA_TO_DISPLAY: 'Keine Daten zum Anzeigen',
    USE_REFERENCE_FILTERS: 'Deren Filter verwenden',
    USE_REFERENCE_TIMELINE: 'Deren Zeitleiste verwenden',
    USE_REFERENCE_ROWS: 'Deren Zeilen verwenden',
    USE_REFERENCE_COLUMNS: 'Deren Spalten verwenden',
    REFERENCE_ANOTHER_SHEET: 'Anderes Tabellenblatt referenzieren',
    NO_SHEET_SELECTED: 'Kein Tabellenblatt ausgewählt',
    SELECT_SHEET: 'Tabellenblatt auswählen',
    SHEET_REFERENCED: 'Tabellenblatt erfolgreich referenziert',
    CANNOT_ADD_ROWS: 'Zeilen können nicht hinzugefügt werden, solange referenziert',
    CANNOT_EDIT_ROWS: 'Zeilen können nicht bearbeitet werden, solange referenziert',
    CANNOT_EDIT_COLUMNS: 'Spalten können nicht bearbeitet werden, solange referenziert',
    CANNOT_ADD_COLUMNS: 'Spalten können nicht hinzugefügt werden, solange referenziert',
    CANNOT_ADD_FILTERS: 'Filter können nicht hinzugefügt werden, solange referenziert',
    REVERSE_DIMENSION: 'umgekehrt verbundene Dimension',
    REMOVE_FROM_RULE: 'Aus Regel entfernen',
    NEW_RULE: 'Neue Regel',
    DUPLICATE_RULE: 'Regel duplizieren',
    REMOVE_RULE: 'Regel entfernen',
    VARIABLE_LOCK_INFO_TITLE: 'Diese Variable wird nur diese Regel verwenden.',
    VARIABLE_LOCK_INFO_BODY: 'Andere Regeln werden überschrieben. Um die gesamte Variable zu sperren, lassen Sie den Dimensionsbereich leer.',
    DELETED: 'Gelöscht',
    DONE: 'Fertig',
    CHOOSE_ITEMS_TO_EXPORT: 'Elemente zum Exportieren auswählen',
    UPLOAD_MODEL_FILE: 'Modelldatei hochladen',
    NO_FILE_SELECTED: 'Keine Datei ausgewählt',
    BACK: 'Zurück',
    ALLOW_IMPORT_TO: 'Import erlauben für',
    FINISHED: 'Abgeschlossen',
    IMPORT_PREVIEW: 'Dies ist eine Vorschau der Änderungen, die der Import mit den aktuellen Einstellungen anwenden würde.\n\nÄnderungen:\n',
    IMPORT_FINISHED: 'Import abgeschlossen.\n\nÄnderungen:\n',
    LOADING_MODEL: 'Modell wird aus Datei importiert...',
    CUSTOM_COLUMN: 'Benutzerdefinierte Spalte',
    EXPAND_ROW_COLUMN_TOOLBAR: 'Zeilen- und Spaltenwerkzeugleiste erweitern',
    SEARCH_FOR_EXPRESSIONS: 'Nach Funktionen, Variablen, Dimensionen suchen…',
    NEW: 'Neu',
    SELECT_A_CELL: 'Wählen Sie eine Zelle mit einem Wert aus, um die Formel anzuzeigen',
    SELECT_A_CELL_TO_EDIT_ROWS: 'Wählen Sie eine Zelle aus, um Zeilen zu bearbeiten',
    OR_COLUMNS: 'oder Spalten',
    MANAGE_PERMISSIONS_FOR: 'Berechtigungen verwalten für "{name}"',
    VIEW_ONLY: 'Nur anzeigen',
    DATA_EDIT: 'Daten bearbeiten',
    EDIT_OWNED: 'Eigene bearbeiten',
    FULL_EDIT: 'Vollständig bearbeiten',
    UNKNOWN_USER: 'Unbekannter Benutzer',
    UNKNOWN_GROUP: 'Unbekannte Gruppe',
    BUTTON_STYLE: 'Schaltflächenstil',
    BUTTON_STYLES: {
        primary: 'Primär',
        secondary: 'Sekundär',
        tertiary: 'Tertiär',
        quaternary: 'Quartär',
    },
    APP_ICON: 'App-Symbol',
    LAST_MODIFIED_BY: 'Zuletzt geändert von {name}',
    LAST_MODIFIED_BY_COLUMN: 'Zuletzt geändert von',
    LAST_MODIFIED_AT_COLUMN: 'Zuletzt geändert am',
    SHOW: 'Anzeigen',
    FORMULA_QA: 'Formel-QA',
    TIME_LIMIT: 'Zeitlimit',
    RESTRICTIONS: 'Einschränkungen',
    SEARCH_FOR_USERS_GROUPS: 'Nach Benutzern oder Gruppen suchen…',
    SEARCH_OR_ADD_USERS_GROUPS: 'Suchen oder mit Benutzern, Gruppen oder öffentlich teilen…',
    STATUS_TRACKING: 'Statusverfolgung',
    STATUS_TRACKING_MESSAGE: 'Die Verfolgung ermöglicht es dem Benutzer oder der Gruppe, ihre Änderungen einzureichen und Ihre Genehmigung anzufordern.',
    TRACK_STATUS: 'Status verfolgen',
    STOP_TRACKING: 'Verfolgung beenden',
    RESTART_TRACKING: 'Verfolgung neu starten',
    ALL: 'Alle',
    TRACKED: 'Nachverfolgt',
    UNTRACKED: 'Nicht nachverfolgt',
    ALL_TRACKED: 'Alle verfolgten',
    MY_TRACKED: 'Meine verfolgten',
    MY_APPROVALS: 'Meine Genehmigungen',
    ALL_SHARES: 'Alle Freigaben',
    SUPER_USERS: 'Super-Benutzer',
    LOADING_SUPER_USERS: 'Super-Benutzer werden geladen...',
    CANNOT_EDIT_WHEN_TIME_LIMIT: 'Bearbeitung nicht möglich, wenn Zeitlimit aktiv ist',
    CANNOT_EDIT_WHEN_TRACKED: 'Bearbeitung nicht möglich, wenn Status verfolgt wird',
    EXPORT_SHARES_TO_XLS: 'Freigaben als .xls exportieren',
    SHARE_COPIED: 'Freigabe kopiert!',
    SHARES_COPIED: 'Freigaben kopiert!',
    COPY_SHARE_IN_FOLDER: 'Auf alles in diesem Ordner kopieren',
    COPY_AND_OVERRIDE_SHARES: 'Freigaben kopieren und überschreiben',
    COPY_AND_OVERRIDE_SHARES_CONFIRMATION: 'Alle bestehenden Freigaben für Elemente und Ordner in diesem Ordner werden durch die Freigaben des aktuellen Ordners ersetzt.',
    COPY_ALL_SHARES_IN_FOLDER: 'Alle Freigaben in diesem Ordner kopieren und überschreiben',
    GRID_SINGLE_CHART_EXPLANATION: 'Einzelnes Diagramm mit Zeilen der obersten Ebene',
    GRID_MULTIPLE_CHART_EXPLANATION: 'Raster kleiner Diagramme, eines für jede Zeile der obersten Ebene',
    DUPLICATE_KEYS_FOUND: 'Doppelte Schlüssel gefunden',
    DUPLICATE_KEYS_PROMPT: 'Möchten Sie filtern und nur die eindeutigen Elemente erstellen?',
    NAMES_SHOULD_BE_UNIQUE: 'Namen sollten eindeutig sein',
    LIMIT_TO_FILTERED_OPTIONS: 'Auf gefilterte Optionen beschränken',

    // Toast messages
    SWITCHING_TENANT: 'Arbeitsbereich wird gewechselt',
    TENANT_SWITCHED_SUCCESS: 'Arbeitsbereich erfolgreich gewechselt',
    TENANT_SWITCH_FAILED: 'Neue Arbeitsbereichsdaten konnten nicht abgerufen werden. Bitte aktualisieren Sie die Seite',
    FAILED_LOAD_MESSAGES: 'Nachrichten konnten nicht geladen werden',
    NEW_CHAT_CREATED: 'Neuer Chat erstellt!',
    FAILED_LOAD_CHATS: 'Chats konnten nicht geladen werden.',
    FAILED_CREATE_CHAT: 'Neuer Chat konnte nicht erstellt werden.',
    FAILED_SEND_MESSAGE: 'Neuer Chat konnte nicht erstellt oder Nachricht nicht gesendet werden.',
    FAILED_RENAME_CHAT: 'Chat konnte nicht umbenannt werden.',
    FAILED_DELETE_CHAT: 'Chat konnte nicht gelöscht werden.',
    XLSX_FILE_ONLY: 'Nur .xlsx-Dateien',
    JSON_FILE_ONLY: 'Nur .json-Dateien',
    EXPORT_DONE: 'Fertig!',
    LOCKS_SAVED: 'Sperren gespeichert',
    COPIED_TO_CLIPBOARD: 'In die Zwischenablage kopiert',
    INVALID_INTERVAL: 'Ungültiges Intervall',
    SELECT_REQUIRED_DIMENSIONS: 'Erforderliche Dimensionen auswählen.',
    ENTITY_TYPE_NOT_SPECIFIED: 'Entitätstyp nicht angegeben',
    FAILED_EXPORT_VARIABLE: 'Variable konnte nicht exportiert werden: {message}',

    // Button labels
    OK: 'OK',
    DELETE_ENTITY: 'Entität löschen',
    SAVE_ENTITY: 'Entität speichern',
    GENERATED_ENTITIES: 'Generierte Entitäten',
    NEW_ENTITY: 'Neue Entität',
    ENTITIES: 'Entitäten',
    SHOW_LOGS: 'Protokolle anzeigen',
    CALCULATE: 'Berechnen',
    FORMULA_QA_TITLE: 'Formel-QA',
    RENAME_CHAT: 'Chat umbenennen',
    SEND: 'Senden',
    EXPORT_CURRENT_SHEET: 'Aktuelles Tabellenblatt exportieren',
    TERMINATE: 'Beenden',
    CONFIRM_UPDATE: 'Aktualisierung bestätigen',

    // Form labels and placeholders
    FROM_DATE: 'Von Datum',
    TO_DATE: 'Bis Datum',
    AUDIT_TYPE: 'Audittyp',
    SELECT_AUDIT_TYPE: 'Audittyp auswählen',
    USER: 'Benutzer',
    PAGE_SIZE: 'Seitengröße',
    SELECT_PAGE_SIZE: 'Seitengröße auswählen',
    SELECT_USER: 'Benutzer auswählen',
    EXPORT_EXPANDED_ROWS: 'Aktuell erweiterte Zeilen exportieren',
    EXPORT_ALL_ROWS: 'Alle Zeilen exportieren',
    EXPORT_FILENAME_LABEL: 'Name',
    INCLUDE_CELLS: 'Zellen einschließen',
    INCLUDE_MEMBERS: 'Mitglieder einschließen',
    MESSAGE_FARSEER_AI: 'Nachricht an FarseerAI...',
    ENTER_NEW_CHAT_NAME: 'Neuen Chat-Namen eingeben',
    FLAG: 'Markierung',

    // Chat suggestions
    CHAT_SUGGESTION_SUMMARY: 'Geben Sie mir eine kurze Zusammenfassung des Modells',
    CHAT_SUGGESTION_DIMENSIONS: 'Gibt es Variablen, die mehr Dimensionen haben als die in ihrer Formel verwendeten Variablen?',
    CHAT_SUGGESTION_DELAY: 'Verwenden Variablen die Funktion delay()?',
    CHAT_SUGGESTION_ONDEMAND: 'Alle On-Demand-Variablen auflisten',
    CHAT_SUGGESTION_MEASURES: 'Alle Kennzahlen auflisten',
    CHAT_SUGGESTION_FIXED: 'Alle Variablen mit einer festen Dimension auflisten',
    CHAT_SUGGESTION_DATE: 'Alle Dimensionen mit einer Datumseigenschaft auflisten',

    // Loading defaults
    DEFAULT_LOADING: 'Wird geladen...',
    DEFAULT_SUCCESS: 'Erfolgreich!',

    // Audit logs
    TOTAL_RESULTS: 'Gesamtergebnisse: {count}',
    PAGE_OF_TOTAL: 'Seite {current} von {total}',
    DB_ID: 'DB-ID',
    DATE_AND_TIME: 'Datum und Uhrzeit',
    LOG_TYPE: 'Protokolltyp',
    DATA: 'Daten',

    // Entity debugger
    NO_TYPES: 'Keine Typen',

    // Formula QA Modal
    RESULT: 'Ergebnis: {value}',
    ENTER_FORMULA_TO_CALCULATE: 'Formel eingeben, um das Ergebnis zu berechnen.',

    // Model export
    EXPORTING_MODEL_ITEMS: 'Ausgewählte Modellelemente werden exportiert...',

    // Search
    RECENTLY_SEARCHED: 'Kürzlich gesucht',
};

export default { ...(baseLanguageValues as Translation), ...translationValues };
